<template>
	<div class="transactionlist">
		<a-layout id="components-layout-demo-side" style="min-height: 100vh">
			<menuBar :current="current" :openKeys="openKeys"></menuBar>
			<a-layout style="overflow: auto;">
				<topBar :fatherMethod="initialize"></topBar>
				<a-layout-content style="margin: 16px; min-width: 1192px;">
					<div style="font-size: 20px;line-height: 30px;margin-bottom: 10px;font-weight: 700;padding-left: 8px;">交易列表</div>
					<div class="contentcard">
						<div style="font-size: 14px; font-weight: 700;">交易搜索</div>
						<a-divider dashed style="margin: 10px 0;" />
						<div style="margin-bottom: 20px;">
							<div style="margin-bottom: 20px;">
								<div style="width: 500px;display: inline-block;">
									<span style="font-size: 14px; font-weight: 700;display: inline-block;width: 100px;text-align: right;margin-right: 30px;">商品名称</span>
									<a-input placeholder="请输入商品名称" style="width: 260px" v-model="searchlist.sku_title" />
								</div>
								<div style="width: 400px;display: inline-block;">
									<span style="font-size: 14px; font-weight: 700;display: inline-block;width: 100px;text-align: right;margin-right: 30px;">订单号</span>
									<a-input placeholder="请输入订单号" style="width: 260px" v-model="searchlist.trade_id" />
								</div>
							</div>
							<div style="margin-bottom: 20px;">
								<div style="width: 500px;display: inline-block;">
									<span style="font-size: 14px; font-weight: 700;display: inline-block;width: 100px;text-align: right;margin-right: 30px;">收件人姓名</span>
									<a-input placeholder="请输入收件人姓名" style="width: 260px" v-model="searchlist.receiver_name" />
								</div>
								<div style="width: 400px;display: inline-block;">
									<span style="font-size: 14px; font-weight: 700;display: inline-block;width: 100px;text-align: right;margin-right: 30px;">收件人手机号</span>
									<a-input placeholder="请输入收件人手机号" style="width: 260px" v-model="searchlist.receiver_phone" />
								</div>
							</div>
							<div style="margin-bottom: 20px;">
								<div style="width: 500px;display: inline-block;">
									<span style="font-size: 14px; font-weight: 700;display: inline-block;width: 100px;text-align: right;margin-right: 30px;">时间范围</span>
									<a-range-picker style="width: 260px" :defaultValue="(!searchlist.start_time&&!searchlist.end_time)?null:[moment(searchlist.start_time, dateFormat),moment(searchlist.end_time, dateFormat)]"
									 @change="onChangeTime" />
								</div>
								<div style="width: 400px;display: inline-block;">
									<span style="font-size: 14px; font-weight: 700;display: inline-block;width: 100px;text-align: right;margin-right: 30px;">会员ID</span>
									<a-input placeholder="请输入会员ID" style="width: 260px" v-model="searchlist.user_id" />
								</div>
							</div>
							<div>
								<div style="width: 500px;display: inline-block;">
									<span style="font-size: 14px; font-weight: 700;display: inline-block;width: 100px;text-align: right;margin-right: 30px;">商品通道</span>
									<a-select placeholder="请选择" v-model="searchlist.product_channel" style="width: 260px;">
										<a-select-option value='0'>全部产品</a-select-option>
										<a-select-option value='1'>大宗贸易</a-select-option>
										<a-select-option value='2'>保税备货</a-select-option>
										<a-select-option value='3'>澳洲直邮</a-select-option>
										<a-select-option value='4'>国货严选</a-select-option>
									</a-select>
								</div>
								<div style="width: 400px;display: inline-block;">
									<span style="font-size: 14px; font-weight: 700;display: inline-block;width: 100px;text-align: right;margin-right: 30px;">买家昵称</span>
									<a-input placeholder="请输入买家昵称" style="width: 260px" v-model="searchlist.nick_name" />
								</div>
							</div>
						</div>
						<div style="text-align: center;">
							<a-button type="primary" style="width: 96px;" @click="searchbtn">搜索</a-button>
						</div>
					</div>
					<div class="card-container">
						<a-tabs :defaultActiveKey="liststatus" :activeKey="liststatus" type="card" :tabBarGutter="5" @change="tabChange">
							<a-tab-pane tab="全部" key="all">
								<div style="padding-bottom: 50px;">
									<div style="display: flow-root;position: relative;margin-bottom: 10px;">
										<a-button type="primary" style="width: 96px;" :disabled="!tradelist.length" @click="exportexcel">导出Excel</a-button>
										<a-button type="primary" @click="link_to" style="float: right;">编辑发货短信模板</a-button>
									</div>
									<div>
										<div v-if="issearch" style="text-align: center;background: rgba(0,0,0,0.05);border-radius: 4px;margin-bottom: 20px;padding: 30px 50px;margin: 20px 0;">
											<a-spin />
										</div>
										<div v-if="(!tradelist.length)&&(!issearch)">
											<a-alert message="查询结果为空" banner type="info" />
										</div>
										<div v-if="tradelist.length">
											<a-row type="flex" justify="space-around" align="middle" style="background-color: #f3f3f5;font-size: 14px;height: 60px;font-weight: 700;">
												<a-col :span="7" style="text-align: center;">商品名称</a-col>
												<a-col :span="3" style="text-align: center;">单价</a-col>
												<a-col :span="2" style="text-align: center;">数量</a-col>
												<a-col :span="2" style="text-align: center;">买家</a-col>
												<a-col :span="4" style="text-align: center;">订单总金额</a-col>
												<a-col :span="6" style="text-align: center;">状态</a-col>
											</a-row>
										</div>
										<div style="color: #666;font-size: 14px;margin-bottom: 20px;" v-for="item in tradelist" :key="item.id">
											<a-row type="flex" justify="space-around" align="middle" style="font-weight: 600;border: #e8e8e8 solid 1px;height: 30px;line-height: 30px;">
												<a-col :span="9" style="text-align: center;">
													<a-tag color="blue" v-if="item.is_cainiao">当日达</a-tag>订单号：{{item.trade_number}}
												</a-col>
												<a-col :span="3" style="text-align: center;">运费：￥{{item.delivery_fee/100}}</a-col>
												<a-col :span="3" style="text-align: center;">订单实付：￥{{item.receipt_price/100}}</a-col>
												<a-col :span="5" style="text-align: center;">创建时间：{{moment(item.created_at).format("YYYY-MM-DD HH:mm:ss")}}</a-col>
												<a-col :span="4" style="text-align: center;" v-if="item.trade_platform==1">订单提交平台：微信</a-col>
												<a-col :span="4" style="text-align: center;" v-if="item.trade_platform==2">订单提交平台：Excel</a-col>
												<a-col :span="4" style="text-align: center;" v-if="item.trade_platform==3">订单提交平台：支付宝</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px;height: 30px;line-height: 30px;border-top: 0px;" v-if="item.is_match_trade">
												<a-col :span="24" style="text-align: center;">该订单为搭配商品购买订单，请注意退款及取消订单相关操作</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px;height: 30px;line-height: 30px;border-top: 0px;" v-if="item.coupon_derate_fee">
												<a-col :span="8" style="text-align: center;">券类型：全店优惠券</a-col>
												<a-col :span="8" style="text-align: center;">券名称：{{item.coupon_card_title}}</a-col>
												<a-col :span="8" style="text-align: center;">优惠券面额：￥{{item.coupon_derate_fee/100}}</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px;height: 30px;line-height: 30px;border-top: 0px;"
											 v-for="(ali_voucher,ali_voucher_index) in item.ali_voucher_detail_list" :key="ali_voucher_index" v-if="item.ali_voucher_detail_list.length>0">
												<a-col :span="8" style="text-align: center;">券类型：{{voucher_type(ali_voucher.type)}}</a-col>
												<a-col :span="8" style="text-align: center;">券名称：{{ali_voucher.name}}</a-col>
												<a-col :span="8" style="text-align: center;">优惠券面额：￥{{ali_voucher.amount}}</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;"
											 v-for="order in item.TC_Orders" :key="order.id">
												<a-col :span="2">
													<div style="width: 70px;height: 70px;background-color: #f3f3f5;">
														<img :src="order.sku_cover" width="70" height="70">
													</div>
												</a-col>
												<a-col :span="5" style="text-align: center;position: relative;">
													<div style="text-align: center;">
														<span>{{order.sku_title}}</span><br />
														<span>{{order.sku_properties}}</span><br />
														<a-tag v-if="item.is_solitaire" color="orange" style="margin: 0;">接龙订单</a-tag>
														<a-tag v-if="item.is_solitaire" color="green" style="margin: 0;">{{solitaireStatus(item)}}</a-tag>
													</div>
												</a-col>
												<a-col :span="3" style="text-align: center;">
													<a-tag color="blue" style="margin: 0;" v-if="order.is_match_order">搭配商品</a-tag><br v-if="order.is_match_order">
													<s v-if="item.UIC_User.member_level !==1&&order.original_price&&order.original_price>order.sku_price">￥{{order.original_price/100}}</s>
													<br v-if="item.UIC_User.member_level !==1&&order.original_price&&order.original_price>order.sku_price" />
													￥{{order.sku_price/100}}
												</a-col>
												<a-col :span="2" style="text-align: center;">{{order.amount}}</a-col>
												<a-col :span="2" style="text-align: center;position: relative;">
													<a-popover trigger="hover">
														<template slot="content">
															<p>ID:{{item.UIC_User.id}}</p>
														</template>
														<div style="text-align: center;position: relative;">
															<span style="display: inline-block;width: 100%;word-break: break-all;white-space: normal;">{{item.UIC_User.nick_name}}</span>
															<a-tag color="orange" style="margin: 0;">{{item.UIC_User.member_level==1?'会员':item.UIC_User.member_level==2?'VIP会员':item.UIC_User.member_level==3?'钻石会员':'皇冠会员'}}</a-tag>
														</div>
													</a-popover>
												</a-col>
												<a-col :span="4" style="text-align: center;">
													<span>
														总价：￥ {{order.sku_price*order.amount/100}} <br>
														应付：￥ {{order.receipt_price/100}} <br>
														<span v-if="order.coupon_derate_fee">商品优惠券满减：￥ -{{order.coupon_derate_fee*order.amount/100}}</span>
													</span>
												</a-col>
												<a-col :span="6" style="text-align: center;color: #0099FF;font-weight: 700;">{{status[order.order_status]}}</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
												<a-col :span="3" style="">收件人姓名：{{item.receiver_name}}</a-col>
												<a-col :span="6" style="">收件人手机号码：{{item.receiver_phone}}</a-col>
												<a-col :span="10" style="">地址：{{item.receiver_address}}
													<a-button size="small" type="dashed" shape="circle-outline" icon="copy" @click="copyaddress(item)" />
												</a-col>
												<a-col :span="5" style="text-align: center;">
													<a-button ghost size="small" type="primary" style="width: 96px;font-size: 12px;" v-if="item.status !='closed'&&item.status !='finished'&&item.status !='success'"
													 @click="modify_address_btn(item)">修改地址</a-button>
													<a-button ghost size="small" type="primary" v-if="item.id_card_id" style="width: 96px;font-size: 12px;"
													 @click="changeidcard(item)">身份证信息</a-button>
												</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
												<a-col :span="24">
													<div style="display: inline-block;">买家备注：</div>
													<span>{{item.remarks}}</span>
												</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
												<a-col :span="19">
													<div style="display: inline-block;">运营备注：</div>
													<span>{{item.business_remarks}}</span>
												</a-col>
												<a-col :span="5" style="text-align: center;">
													<a-button ghost size="small" type="primary" style="width: 96px;font-size: 12px;" @click="modify_business_remarks_btn(item)">修改运营备注</a-button>
												</a-col>
											</a-row>
											<a-row v-if="(item.first_agency_id||item.second_agency_id)&&!(item.profitsharing_info||item.profitsharing_fail_info)"
											 type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
												<a-col :span="24">
													<span>该订单含有代理分账：</span>
													<a-button @click="profitsharingquery(item)">查询</a-button>
												</a-col>

											</a-row>
											<a-row v-if="item.profitsharing_info||item.profitsharing_fail_info" type="flex" justify="space-around" align="middle"
											 style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
												<a-col :span="24">
													分账状态提交记录：{{item.is_clear?'已提交':'未提交'}}
												</a-col>
												<a-col :span="4">
													一级代理分账信息：
												</a-col>
												<a-col :span="8">
													{{get_first_info(item)}}
												</a-col>
												<a-col :span="4">
													二级代理分账信息：
												</a-col>
												<a-col :span="8">
													{{get_second_info(item)}}
												</a-col>
											</a-row>
											<a-row v-if="item.profitsharing_fail_info" type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
												<a-col :span="18">
													<span>{{item.profitsharing_fail_info}}</span>
												</a-col>
												<a-col :span="6">
													<a-button @click="profitsharingfinish(item)">尝试完结分账</a-button>
												</a-col>
											</a-row>
											<a-row v-if="item.profitsharing_info" type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
												<a-col :span="24">
													实际分账信息：{{item.profitsharing_info.status}}
												</a-col>
												<a-col :span="8" v-for="(receivers,receiversindex) in item.profitsharing_info.receivers" :key="receiversindex">
													<div v-if="receivers.type == 'MERCHANT_ID'">
														{{receivers.description}},金额￥:{{receivers.amount/100}}
													</div>
													<div v-if="receivers.type == 'PERSONAL_OPENID'">
														账户:{{receivers.user_id}},实际分账金额￥:{{receivers.amount/100}}
													</div>
												</a-col>
											</a-row>
										</div>
									</div>
									<div style="float: right;position: relative;bottom: -18px;">
										<a-pagination showSizeChanger @showSizeChange="onShowSizeChange" :current="endpage/pageSize" :pageSize="pageSize"
										 :total="tradesum" showQuickJumper @change="pageChange" />
									</div>
								</div>
							</a-tab-pane>
							<a-tab-pane tab="待付款" key="to_be_paid">
								<div style="padding-bottom: 50px;">
									<div style="display: flow-root;position: relative;margin-bottom: 10px;">
										<a-button type="primary" style="width: 96px;" :disabled="!tradelist.length" @click="exportexcel">导出Excel</a-button>
										<a-button type="primary" @click="link_to" style="float: right;">编辑发货短信模板</a-button>
									</div>
									<div>
										<div v-if="issearch" style="text-align: center;background: rgba(0,0,0,0.05);border-radius: 4px;margin-bottom: 20px;padding: 30px 50px;margin: 20px 0;">
											<a-spin />
										</div>
										<div v-if="(!tradelist.length)&&(!issearch)">
											<a-alert message="查询结果为空" banner type="info" />
										</div>
										<div v-if="tradelist.length">
											<a-row type="flex" justify="space-around" align="middle" style="background-color: #f3f3f5;font-size: 14px;height: 60px;font-weight: 700;">
												<a-col :span="8" style="text-align: center;">商品名称</a-col>
												<a-col :span="3" style="text-align: center;">单价</a-col>
												<a-col :span="2" style="text-align: center;">数量</a-col>
												<a-col :span="2" style="text-align: center;">买家</a-col>
												<a-col :span="4" style="text-align: center;">订单总金额</a-col>
												<a-col :span="5" style="text-align: center;">操作</a-col>
											</a-row>
										</div>
										<div style="color: #666;font-size: 14px;margin-bottom: 20px;" v-for="item in tradelist" :key="item.id">
											<a-row type="flex" justify="space-around" align="middle" style="font-weight: 600;border: #e8e8e8 solid 1px;height: 30px;line-height: 30px;">
												<a-col :span="9" style="text-align: center;">
													<a-tag color="blue" v-if="item.is_cainiao">当日达</a-tag>订单号：{{item.trade_number}}
												</a-col>
												<a-col :span="3" style="text-align: center;">运费：￥{{item.delivery_fee/100}}</a-col>
												<a-col :span="3" style="text-align: center;">订单实付：￥{{item.receipt_price/100}}</a-col>
												<a-col :span="5" style="text-align: center;">创建时间：{{moment(item.created_at).format("YYYY-MM-DD HH:mm:ss")}}</a-col>
												<a-col :span="4" style="text-align: center;" v-if="item.trade_platform==1">订单提交平台：微信</a-col>
												<a-col :span="4" style="text-align: center;" v-if="item.trade_platform==2">订单提交平台：Excel</a-col>
												<a-col :span="4" style="text-align: center;" v-if="item.trade_platform==3">订单提交平台：支付宝</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px;height: 30px;line-height: 30px;border-top: 0px;" v-if="item.is_match_trade">
												<a-col :span="24" style="text-align: center;">该订单为搭配商品购买订单，请注意退款及取消订单相关操作</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px;height: 30px;line-height: 30px;border-top: 0px;" v-if="item.coupon_derate_fee">
												<a-col :span="8" style="text-align: center;">券类型：全店优惠券</a-col>
												<a-col :span="8" style="text-align: center;">券名称：{{item.coupon_card_title}}</a-col>
												<a-col :span="8" style="text-align: center;">优惠券面额：￥{{item.coupon_derate_fee/100}}</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px;height: 30px;line-height: 30px;border-top: 0px;"
											 v-for="(ali_voucher,ali_voucher_index) in item.ali_voucher_detail_list" :key="ali_voucher_index" v-if="item.ali_voucher_detail_list.length>0">
												<a-col :span="8" style="text-align: center;">券类型：{{voucher_type(ali_voucher.type)}}</a-col>
												<a-col :span="8" style="text-align: center;">券名称：￥{{ali_voucher.name}}</a-col>
												<a-col :span="8" style="text-align: center;">优惠券面额：￥{{ali_voucher.amount}}</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;"
											 v-for="(order,order_index) in item.TC_Orders" :key="order.id">
												<a-col :span="2">
													<div style="width: 70px;height: 70px;background-color: #f3f3f5;">
														<img :src="order.sku_cover" width="70" height="70">
													</div>
												</a-col>
												<a-col :span="5" style="text-align: center;position: relative;">
													<div style="text-align: center;">
														<span>{{order.sku_title}}</span><br />
														<span>{{order.sku_properties}}</span><br />
														<a-tag v-if="item.is_solitaire" color="orange" style="margin: 0;">接龙订单</a-tag>
														<a-tag v-if="item.is_solitaire" color="green" style="margin: 0;">{{solitaireStatus(item)}}</a-tag>
													</div>
												</a-col>
												<a-col :span="3" style="text-align: center;">
													<a-tag color="blue" style="margin: 0;" v-if="order.is_match_order">搭配商品</a-tag><br v-if="order.is_match_order">
													<s v-if="item.UIC_User.member_level !==1&&order.original_price&&order.original_price>order.sku_price">￥{{order.original_price/100}}</s>
													<br v-if="item.UIC_User.member_level !==1&&order.original_price&&order.original_price>order.sku_price" />
													￥{{order.sku_price/100}}
												</a-col>
												<a-col :span="2" style="text-align: center;">{{order.amount}}</a-col>
												<a-col :span="2" style="text-align: center;position: relative;">
													<a-popover trigger="hover">
														<template slot="content">
															<p>ID:{{item.UIC_User.id}}</p>
														</template>
														<div style="text-align: center;position: relative;">
															<span style="display: inline-block;width: 100%;word-break: break-all;white-space: normal;">{{item.UIC_User.nick_name}}</span>
															<a-tag color="orange" style="margin: 0;">{{item.UIC_User.member_level==1?'会员':item.UIC_User.member_level==2?'VIP会员':item.UIC_User.member_level==3?'钻石会员':'皇冠会员'}}</a-tag>
														</div>
													</a-popover>
												</a-col>
												<a-col :span="4" style="text-align: center;">
													<span>
														总价：￥ {{order.sku_price*order.amount/100}} <br>
														应付：￥ {{order.receipt_price/100}} <br>
														<span v-if="order.coupon_derate_fee">商品优惠券满减：￥ -{{order.coupon_derate_fee*order.amount/100}}</span>
													</span>
												</a-col>
												<a-col :span="4" style="text-align: center;">
													<a-button ghost disabled size="small" type="primary" style="width: 128px;font-size: 12px;" v-if="item.hb_number>0">花呗订单无法改价</a-button>
													<a-button ghost size="small" type="primary" style="width: 96px;font-size: 12px;" @click="modify_price_btn(item,order)"
													 v-else>修改价格</a-button>
													 <a-button ghost type="danger" size="small" style="width: 96px;font-size: 12px;margin-top: 10px;" @click="cancelbtn(order,1)" v-if="order_index==0">整单取消</a-button>
												</a-col>
												<!-- <a-col :span="6" style="text-align: center;color: #0099FF;font-weight: 700;">{{status[order.order_status]}}</a-col> -->
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
												<a-col :span="3" style="">收件人姓名：{{item.receiver_name}}</a-col>
												<a-col :span="6" style="">收件人手机号码：{{item.receiver_phone}}</a-col>
												<a-col :span="10" style="">地址：{{item.receiver_address}}
													<a-button size="small" type="dashed" shape="circle-outline" icon="copy" @click="copyaddress(item)" />
												</a-col>
												<a-col :span="5" style="text-align: center;">
													<a-button ghost size="small" type="primary" style="width: 96px;font-size: 12px;" @click="modify_address_btn(item)">修改地址</a-button>
													<a-button ghost size="small" type="primary" v-if="item.id_card_id" style="width: 96px;font-size: 12px;"
													 @click="changeidcard(item)">身份证信息</a-button>
												</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
												<a-col :span="24">
													<div style="display: inline-block;">买家备注：</div>
													<span>{{item.remarks}}</span>
												</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
												<a-col :span="19">
													<div style="display: inline-block;">运营备注：</div>
													<span>{{item.business_remarks}}</span>
												</a-col>
												<a-col :span="5" style="text-align: center;">
													<a-button ghost size="small" type="primary" style="width: 96px;font-size: 12px;" @click="modify_business_remarks_btn(item)">修改运营备注</a-button>
												</a-col>
											</a-row>
										</div>
									</div>
									<div style="float: right;position: relative;bottom: -18px;">
										<a-pagination showSizeChanger @showSizeChange="onShowSizeChange" :current="endpage/pageSize" :pageSize="pageSize"
										 :total="tradesum" showQuickJumper @change="pageChange" />
									</div>
								</div>
							</a-tab-pane>
							<a-tab-pane tab="待发货" key="have_paid">
								<div style="padding-bottom: 50px;">
									<div style="display: flow-root;position: relative;margin-bottom: 10px;">
										<a-button type="primary" style="width: 96px;margin-right: 15px;" :disabled="!tradelist.length" @click="exportexcel">导出Excel</a-button>
										<a-button type="primary" :disabled="true" @click="daoru">导入物流单号</a-button>
										<!-- <a-upload name="excelfile" :multiple="false" action="/upload/excel" headers="authorization-text"
										 @change="daoru" :beforeUpload="beforeUpload">
											<a-button type="primary">
												<a-icon type="upload" />导入物流单号</a-button>
										</a-upload> -->
										<a-button type="primary" @click="link_to" style="float: right;">编辑发货短信模板</a-button>
									</div>
									<div>
										<div v-if="issearch" style="text-align: center;background: rgba(0,0,0,0.05);border-radius: 4px;margin-bottom: 20px;padding: 30px 50px;margin: 20px 0;">
											<a-spin />
										</div>
										<div v-if="(!tradelist.length)&&(!issearch)">
											<a-alert message="查询结果为空" banner type="info" />
										</div>
										<div v-if="tradelist.length">
											<a-row type="flex" justify="space-around" align="middle" style="background-color: #f3f3f5;font-size: 14px;height: 60px;font-weight: 700;">
												<a-col :span="7" style="text-align: center;">商品名称</a-col>
												<a-col :span="3" style="text-align: center;">单价</a-col>
												<a-col :span="2" style="text-align: center;">数量</a-col>
												<a-col :span="2" style="text-align: center;">买家</a-col>
												<a-col :span="4" style="text-align: center;">订单总金额</a-col>
												<a-col :span="6" style="text-align: center;">操作</a-col>
											</a-row>
										</div>
										<div style="color: #666;font-size: 14px;margin-bottom: 20px;" v-for="item in tradelist" :key="item.id">
											<a-row type="flex" justify="space-around" align="middle" style="font-weight: 600;border: #e8e8e8 solid 1px;height: 30px;line-height: 30px;">
												<a-col :span="9" style="text-align: center;">
													<a-tag color="blue" v-if="item.is_cainiao">当日达</a-tag>订单号：{{item.trade_number}}
												</a-col>
												<a-col :span="3" style="text-align: center;">运费：￥{{item.delivery_fee/100}}</a-col>
												<a-col :span="3" style="text-align: center;">订单实付：￥{{item.receipt_price/100}}</a-col>
												<a-col :span="5" style="text-align: center;">创建时间：{{moment(item.created_at).format("YYYY-MM-DD HH:mm:ss")}}</a-col>
												<a-col :span="4" style="text-align: center;" v-if="item.trade_platform==1">订单提交平台：微信</a-col>
												<a-col :span="4" style="text-align: center;" v-if="item.trade_platform==2">订单提交平台：Excel</a-col>
												<a-col :span="4" style="text-align: center;" v-if="item.trade_platform==3">订单提交平台：支付宝</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px;height: 30px;line-height: 30px;border-top: 0px;" v-if="item.is_match_trade">
												<a-col :span="24" style="text-align: center;">该订单为搭配商品购买订单，请注意退款及取消订单相关操作</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px;height: 30px;line-height: 30px;border-top: 0px;" v-if="item.coupon_derate_fee">
												<a-col :span="8" style="text-align: center;">券类型：全店优惠券</a-col>
												<a-col :span="8" style="text-align: center;">券名称：{{item.coupon_card_title}}</a-col>
												<a-col :span="8" style="text-align: center;">优惠券面额：￥{{item.coupon_derate_fee/100}}</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px;height: 30px;line-height: 30px;border-top: 0px;"
											 v-for="(ali_voucher,ali_voucher_index) in item.ali_voucher_detail_list" :key="ali_voucher_index" v-if="item.ali_voucher_detail_list.length>0">
												<a-col :span="8" style="text-align: center;">券类型：{{voucher_type(ali_voucher.type)}}</a-col>
												<a-col :span="8" style="text-align: center;">券名称：￥{{ali_voucher.name}}</a-col>
												<a-col :span="8" style="text-align: center;">优惠券面额：￥{{ali_voucher.amount}}</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;"
											 v-for="(order,order_index) in item.TC_Orders" :key="order.id">
												<a-col :span="2">
													<div style="width: 70px;height: 70px;background-color: #f3f3f5;">
														<img :src="order.sku_cover" width="70" height="70">
													</div>
												</a-col>
												<a-col :span="5" style="text-align: center;position: relative;">
													<div style="text-align: center;">
														<span>{{order.sku_title}}</span><br />
														<span>{{order.sku_properties}}</span><br />
														<a-tag v-if="item.is_solitaire" color="orange" style="margin: 0;">接龙订单</a-tag>
														<a-tag v-if="item.is_solitaire" color="green" style="margin: 0;">{{solitaireStatus(item)}}</a-tag>
													</div>
												</a-col>
												<a-col :span="3" style="text-align: center;">
													<a-tag color="blue" style="margin: 0;" v-if="order.is_match_order">搭配商品</a-tag><br v-if="order.is_match_order">
													<s v-if="item.UIC_User.member_level !==1&&order.original_price&&order.original_price>order.sku_price">￥{{order.original_price/100}}</s>
													<br v-if="item.UIC_User.member_level !==1&&order.original_price&&order.original_price>order.sku_price" />
													￥{{order.sku_price/100}}
												</a-col>
												<a-col :span="2" style="text-align: center;">{{order.amount}}</a-col>
												<a-col :span="2" style="text-align: center;position: relative;">
													<a-popover trigger="hover">
														<template slot="content">
															<p>ID:{{item.UIC_User.id}}</p>
														</template>
														<div style="text-align: center;position: relative;">
															<span style="display: inline-block;width: 100%;word-break: break-all;white-space: normal;">{{item.UIC_User.nick_name}}</span>
															<a-tag color="orange" style="margin: 0;">{{item.UIC_User.member_level==1?'会员':item.UIC_User.member_level==2?'VIP会员':item.UIC_User.member_level==3?'钻石会员':'皇冠会员'}}</a-tag>
														</div>
													</a-popover>
												</a-col>
												<a-col :span="4" style="text-align: center;">
													<span>
														总价：￥ {{order.sku_price*order.amount/100}} <br>
														应付：￥ {{order.receipt_price/100}} <br>
														<span v-if="order.coupon_derate_fee">商品优惠券满减：￥ -{{order.coupon_derate_fee*order.amount/100}}</span>
													</span>
												</a-col>
												<a-col :span="1" />
												<a-col :span="5" style="text-align: center;">
													<div style="text-align: center;" v-if="order.order_status =='have_paid'">
														<a-button ghost type="danger" size="small" style="width: 96px;margin-bottom: 5px;font-size: 12px;" v-if="!order.is_refund"
														 @click="refund_btn(order,item)">退款</a-button><br />
														<a-button ghost type="danger" size="small" style="width: 96px;margin-bottom: 5px;font-size: 12px;" v-if="order.is_refund"
														 :disabled="true">订单退款中......</a-button><br v-if="order.is_refund" />
														<a-button ghost type="danger" size="small" style="width: 96px;font-size: 12px;" @click="cancelbtn(order,1)" v-if="item.is_match_trade&&order_index==0">整单取消</a-button>
														<a-button ghost type="danger" size="small" style="width: 96px;font-size: 12px;" @click="cancelbtn(order,0)" v-if="!item.is_match_trade">取消订单</a-button>
													</div>
													<div style="text-align: center;color: #0099FF;font-weight: 700;" v-else-if="order.order_status =='refund'">退款售后</div>
													<div style="text-align: center;color: #0099FF;font-weight: 700;" v-else-if="order.order_status =='closed'">已取消</div>
													<div style="text-align: center;color: #0099FF;font-weight: 700;" v-else-if="order.order_status =='delivery'">物流已发出</div>
												</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
												<a-col :span="3" style="">收件人姓名：{{item.receiver_name}}</a-col>
												<a-col :span="6" style="">收件人手机号码：{{item.receiver_phone}}</a-col>
												<a-col :span="10" style="">地址：{{item.receiver_address}}
													<a-button size="small" type="dashed" shape="circle-outline" icon="copy" @click="copyaddress(item)" />
												</a-col>
												<a-col :span="5" style="text-align: center;">
													<a-button ghost size="small" type="primary" style="width: 96px;font-size: 12px;" @click="modify_address_btn(item)">修改地址</a-button>
													<a-button ghost size="small" type="primary" v-if="item.id_card_id" style="width: 96px;font-size: 12px;"
													 @click="changeidcard(item)">身份证信息</a-button>
												</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
												<a-col :span="24">
													<div style="display: inline-block;">买家备注：</div>
													<span>{{item.remarks}}</span>
												</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
												<a-col :span="19">
													<div style="display: inline-block;">运营备注：</div>
													<span>{{item.business_remarks}}</span>
												</a-col>
												<a-col :span="5" style="text-align: center;">
													<a-button ghost size="small" type="primary" style="width: 96px;font-size: 12px;" @click="modify_business_remarks_btn(item)">修改运营备注</a-button>
												</a-col>
											</a-row>
											<div v-for="(express,ind) in item.TC_Delivery_Infos" :key="ind">
												<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
													<a-col :span="5" style="">物流公司：{{express.express_display}}</a-col>
													<a-col :span="5" style="">快递单号：{{express.express_number}}</a-col>
													<a-col :span="9" style="">备注信息：{{express.remarks}}</a-col>
													<a-col :span="5" style="text-align: center;">
														<a-button ghost size="small" type="primary" style="width: 96px;font-size: 12px;" @click="modify_express_number_btn(item,express)">修改单号</a-button>
														<a-button ghost size="small" type="primary" style="width: 96px;font-size: 12px;" @click="query_express_btn(express,true)">查询物流</a-button>
														<!-- <a-button type="primary" size="small" ghost icon="caret-up" v-if="express.query" @click="()=>{express.query = !express.query}" /> -->
														<!-- <a-button type="primary" size="small" ghost icon="caret-down" v-else @click="()=>{express.query = !express.query}" /> -->
													</a-col>
												</a-row>
												<a-row type="flex" justify="space-around" align="middle">
													<a-col v-if="express.query&&express.delivery_info&&express.delivery_info.nu" :span="24" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
														<a-steps direction="vertical" size="small" progressDot>
															<a-step v-for="(info,index) in express.delivery_info.data" :key="index" status="process" :title="info.time"
															 :description="info.context" />
														</a-steps>
													</a-col>
													<a-col v-if="express.query&&(!express.delivery_info||!express.delivery_info.nu)" :span="24" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">暂无信息</a-col>
												</a-row>
											</div>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
												<a-col :span="24" style="text-align: center;">
													<a-button ghost type="primary" size="small" style="width: 96px;margin-bottom: 5px;font-size: 12px;" @click="express_btn(item,item.receiver_phone,item.id_card_id)">发货</a-button>
												</a-col>
											</a-row>
										</div>
									</div>
									<div style="float: right;position: relative;bottom: -18px;">
										<a-pagination showSizeChanger @showSizeChange="onShowSizeChange" :current="endpage/pageSize" :pageSize="pageSize"
										 :total="tradesum" showQuickJumper @change="pageChange" />
									</div>
								</div>
							</a-tab-pane>
							<a-tab-pane tab="已发货" key="delivery">
								<div style="padding-bottom: 50px;">
									<div style="display: flow-root;position: relative;margin-bottom: 10px;">
										<a-button type="primary" style="width: 96px;" :disabled="!tradelist.length" @click="exportexcel">导出Excel</a-button>
										<a-button type="primary" @click="link_to" style="float: right;">编辑发货短信模板</a-button>
									</div>
									<div>
										<div v-if="issearch" style="text-align: center;background: rgba(0,0,0,0.05);border-radius: 4px;margin-bottom: 20px;padding: 30px 50px;margin: 20px 0;">
											<a-spin />
										</div>
										<div v-if="(!tradelist.length)&&(!issearch)">
											<a-alert message="查询结果为空" banner type="info" />
										</div>
										<div v-if="tradelist.length">
											<a-row type="flex" justify="space-around" align="middle" style="background-color: #f3f3f5;font-size: 14px;height: 60px;font-weight: 700;">
												<a-col :span="7" style="text-align: center;">商品名称</a-col>
												<a-col :span="3" style="text-align: center;">单价</a-col>
												<a-col :span="2" style="text-align: center;">数量</a-col>
												<a-col :span="2" style="text-align: center;">买家</a-col>
												<a-col :span="4" style="text-align: center;">订单总金额</a-col>
												<a-col :span="6" style="text-align: center;">操作</a-col>
											</a-row>
										</div>
										<div style="color: #666;font-size: 14px;margin-bottom: 20px;" v-for="item in tradelist" :key="item.id">
											<a-row type="flex" justify="space-around" align="middle" style="font-weight: 600;border: #e8e8e8 solid 1px;height: 30px;line-height: 30px;">
												<a-col :span="9" style="text-align: center;">
													<a-tag color="blue" v-if="item.is_cainiao">当日达</a-tag>订单号：{{item.trade_number}}
												</a-col>
												<a-col :span="3" style="text-align: center;">运费：￥{{item.delivery_fee/100}}</a-col>
												<a-col :span="3" style="text-align: center;">订单实付：￥{{item.receipt_price/100}}</a-col>
												<a-col :span="5" style="text-align: center;">创建时间：{{moment(item.created_at).format("YYYY-MM-DD HH:mm:ss")}}</a-col>
												<a-col :span="4" style="text-align: center;" v-if="item.trade_platform==1">订单提交平台：微信</a-col>
												<a-col :span="4" style="text-align: center;" v-if="item.trade_platform==2">订单提交平台：Excel</a-col>
												<a-col :span="4" style="text-align: center;" v-if="item.trade_platform==3">订单提交平台：支付宝</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px;height: 30px;line-height: 30px;border-top: 0px;" v-if="item.is_match_trade">
												<a-col :span="24" style="text-align: center;">该订单为搭配商品购买订单，请注意退款及取消订单相关操作</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px;height: 30px;line-height: 30px;border-top: 0px;" v-if="item.coupon_derate_fee">
												<a-col :span="8" style="text-align: center;">券类型：全店优惠券</a-col>
												<a-col :span="8" style="text-align: center;">券名称：{{item.coupon_card_title}}</a-col>
												<a-col :span="8" style="text-align: center;">优惠券面额：￥{{item.coupon_derate_fee/100}}</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px;height: 30px;line-height: 30px;border-top: 0px;"
											 v-for="(ali_voucher,ali_voucher_index) in item.ali_voucher_detail_list" :key="ali_voucher_index" v-if="item.ali_voucher_detail_list.length>0">
												<a-col :span="8" style="text-align: center;">券类型：{{voucher_type(ali_voucher.type)}}</a-col>
												<a-col :span="8" style="text-align: center;">券名称：￥{{ali_voucher.name}}</a-col>
												<a-col :span="8" style="text-align: center;">优惠券面额：￥{{ali_voucher.amount}}</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;"
											 v-for="order in item.TC_Orders" :key="order.id">
												<a-col :span="2">
													<div style="width: 70px;height: 70px;background-color: #f3f3f5;">
														<img :src="order.sku_cover" width="70" height="70">
													</div>
												</a-col>
												<a-col :span="5" style="text-align: center;position: relative;">
													<div style="text-align: center;">
														<span>{{order.sku_title}}</span><br />
														<span>{{order.sku_properties}}</span><br />
														<a-tag v-if="item.is_solitaire" color="orange" style="margin: 0;">接龙订单</a-tag>
														<a-tag v-if="item.is_solitaire" color="green" style="margin: 0;">{{solitaireStatus(item)}}</a-tag>
													</div>
												</a-col>
												<a-col :span="3" style="text-align: center;">
													<a-tag color="blue" style="margin: 0;" v-if="order.is_match_order">搭配商品</a-tag><br v-if="order.is_match_order">
													<s v-if="item.UIC_User.member_level !==1&&order.original_price&&order.original_price>order.sku_price">￥{{order.original_price/100}}</s>
													<br v-if="item.UIC_User.member_level !==1&&order.original_price&&order.original_price>order.sku_price" />
													￥{{order.sku_price/100}}
												</a-col>
												<a-col :span="2" style="text-align: center;">{{order.amount}}</a-col>
												<a-col :span="2" style="text-align: center;position: relative;">
													<a-popover trigger="hover">
														<template slot="content">
															<p>ID:{{item.UIC_User.id}}</p>
														</template>
														<div style="text-align: center;position: relative;">
															<span style="display: inline-block;width: 100%;word-break: break-all;white-space: normal;">{{item.UIC_User.nick_name}}</span>
															<a-tag color="orange" style="margin: 0;">{{item.UIC_User.member_level==1?'会员':item.UIC_User.member_level==2?'VIP会员':item.UIC_User.member_level==3?'钻石会员':'皇冠会员'}}</a-tag>
														</div>
													</a-popover>
												</a-col>
												<a-col :span="4" style="text-align: center;">
													<span>
														总价：￥ {{order.sku_price*order.amount/100}} <br>
														应付：￥ {{order.receipt_price/100}} <br>
														<span v-if="order.coupon_derate_fee">商品优惠券满减：￥ -{{order.coupon_derate_fee*order.amount/100}}</span>
													</span>
												</a-col>
												<a-col :span="1" />
												<a-col :span="5" style="text-align: center;">
													<div style="text-align: center;" v-if="order.order_status =='delivery'">
														<a-button ghost type="danger" size="small" style="width: 96px;margin-bottom: 5px;font-size: 12px;" v-if="!order.is_refund"
														 @click="refund_btn(order,item)">退款</a-button><br />
														<a-button ghost type="danger" size="small" style="width: 96px;margin-bottom: 5px;font-size: 12px;" v-if="order.is_refund"
														 :disabled="true">订单退款中......</a-button><br v-if="order.is_refund" />
													</div>
													<div style="text-align: center;color: #0099FF;font-weight: 700;" v-else-if="order.order_status =='refund'">退款售后</div>
													<div style="text-align: center;color: #0099FF;font-weight: 700;" v-else-if="order.order_status =='closed'">已取消</div>
													<!-- <div style="text-align: center;color: #0099FF;font-weight: 700;" v-else-if="order.order_status =='close'">交易已关闭</div> -->
												</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
												<a-col :span="3" style="">收件人姓名：{{item.receiver_name}}</a-col>
												<a-col :span="6" style="">收件人手机号码：{{item.receiver_phone}}</a-col>
												<a-col :span="10" style="">地址：{{item.receiver_address}}
													<a-button size="small" type="dashed" shape="circle-outline" icon="copy" @click="copyaddress(item)" />
												</a-col>
												<a-col :span="5" style="text-align: center;">
													<a-button ghost size="small" type="primary" style="width: 96px;font-size: 12px;" @click="modify_address_btn(item)">修改地址</a-button>
													<a-button ghost size="small" type="primary" v-if="item.id_card_id" style="width: 96px;font-size: 12px;"
													 @click="changeidcard(item)">身份证信息</a-button>
												</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
												<a-col :span="24">
													<div style="display: inline-block;">买家备注：</div>
													<span>{{item.remarks}}</span>
												</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
												<a-col :span="19">
													<div style="display: inline-block;">运营备注：</div>
													<span>{{item.business_remarks}}</span>
												</a-col>
												<a-col :span="5" style="text-align: center;">
													<a-button ghost size="small" type="primary" style="width: 96px;font-size: 12px;" @click="modify_business_remarks_btn(item)">修改运营备注</a-button>
												</a-col>
											</a-row>
											<div v-for="(express,ind) in item.TC_Delivery_Infos" :key="ind">
												<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
													<a-col :span="5" style="">物流公司：{{express.express_display}}</a-col>
													<a-col :span="5" style="">快递单号：{{express.express_number}}</a-col>
													<a-col :span="9" style="">备注信息：{{express.remarks}}</a-col>
													<a-col :span="5" style="text-align: center;">
														<a-button ghost size="small" type="primary" style="width: 96px;font-size: 12px;" @click="modify_express_number_btn(item,express)">修改单号</a-button>
														<a-button ghost size="small" type="primary" style="width: 96px;font-size: 12px;" @click="query_express_btn(express,true)">查询物流</a-button>
														<!-- <a-button type="primary" size="small" ghost icon="caret-up" v-if="express.query" @click="()=>{express.query = !express.query}" /> -->
														<!-- <a-button type="primary" size="small" ghost icon="caret-down" v-else @click="()=>{express.query = !express.query}" /> -->
													</a-col>
												</a-row>
												<a-row type="flex" justify="space-around" align="middle">
													<a-col v-if="express.query&&express.delivery_info&&express.delivery_info.nu" :span="24" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
														<a-steps direction="vertical" size="small" progressDot>
															<a-step v-for="(info,index) in express.delivery_info.data" :key="index" status="process" :title="info.time"
															 :description="info.context" />
														</a-steps>
													</a-col>
													<a-col v-if="express.query&&(!express.delivery_info||!express.delivery_info.nu)" :span="24" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">暂无信息</a-col>
												</a-row>
											</div>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
												<a-col :span="24" style="text-align: center;">
													<a-button ghost type="primary" size="small" style="width: 96px;margin-bottom: 5px;font-size: 12px;" @click="express_btn(item,item.receiver_phone,item.id_card_id)">发货</a-button>
												</a-col>
											</a-row>
										</div>
									</div>
									<div style="float: right;position: relative;bottom: -18px;">
										<a-pagination showSizeChanger @showSizeChange="onShowSizeChange" :current="endpage/pageSize" :pageSize="pageSize"
										 :total="tradesum" showQuickJumper @change="pageChange" />
									</div>
								</div>
							</a-tab-pane>
							<a-tab-pane tab="已完成" key="finished">
								<div style="padding-bottom: 50px;">
									<div style="display: flow-root;position: relative;margin-bottom: 10px;">
										<a-button type="primary" style="width: 96px;" :disabled="!tradelist.length" @click="exportexcel">导出Excel</a-button>
										<a-button type="primary" @click="link_to" style="float: right;">编辑发货短信模板</a-button>
									</div>
									<div>
										<div v-if="issearch" style="text-align: center;background: rgba(0,0,0,0.05);border-radius: 4px;margin-bottom: 20px;padding: 30px 50px;margin: 20px 0;">
											<a-spin />
										</div>
										<div v-if="(!tradelist.length)&&(!issearch)">
											<a-alert message="查询结果为空" banner type="info" />
										</div>
										<div v-if="tradelist.length">
											<a-row type="flex" justify="space-around" align="middle" style="background-color: #f3f3f5;font-size: 14px;height: 60px;font-weight: 700;">
												<a-col :span="7" style="text-align: center;">商品名称</a-col>
												<a-col :span="3" style="text-align: center;">单价</a-col>
												<a-col :span="2" style="text-align: center;">数量</a-col>
												<a-col :span="2" style="text-align: center;">买家</a-col>
												<a-col :span="4" style="text-align: center;">订单总金额</a-col>
												<a-col :span="6" style="text-align: center;">状态</a-col>
											</a-row>
										</div>
										<div style="color: #666;font-size: 14px;margin-bottom: 20px;" v-for="item in tradelist" :key="item.id">
											<a-row type="flex" justify="space-around" align="middle" style="font-weight: 600;border: #e8e8e8 solid 1px;height: 30px;line-height: 30px;">
												<a-col :span="9" style="text-align: center;">
													<a-tag color="blue" v-if="item.is_cainiao">当日达</a-tag>订单号：{{item.trade_number}}
												</a-col>
												<a-col :span="3" style="text-align: center;">运费：￥{{item.delivery_fee/100}}</a-col>
												<a-col :span="3" style="text-align: center;">订单实付：￥{{item.receipt_price/100}}</a-col>
												<a-col :span="5" style="text-align: center;">创建时间：{{moment(item.created_at).format("YYYY-MM-DD HH:mm:ss")}}</a-col>
												<a-col :span="4" style="text-align: center;" v-if="item.trade_platform==1">订单提交平台：微信</a-col>
												<a-col :span="4" style="text-align: center;" v-if="item.trade_platform==2">订单提交平台：Excel</a-col>
												<a-col :span="4" style="text-align: center;" v-if="item.trade_platform==3">订单提交平台：支付宝</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px;height: 30px;line-height: 30px;border-top: 0px;" v-if="item.is_match_trade">
												<a-col :span="24" style="text-align: center;">该订单为搭配商品购买订单，请注意退款及取消订单相关操作</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px;height: 30px;line-height: 30px;border-top: 0px;" v-if="item.coupon_derate_fee">
												<a-col :span="8" style="text-align: center;">券类型：全店优惠券</a-col>
												<a-col :span="8" style="text-align: center;">券名称：{{item.coupon_card_title}}</a-col>
												<a-col :span="8" style="text-align: center;">优惠券面额：￥{{item.coupon_derate_fee/100}}</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px;height: 30px;line-height: 30px;border-top: 0px;"
											 v-for="(ali_voucher,ali_voucher_index) in item.ali_voucher_detail_list" :key="ali_voucher_index" v-if="item.ali_voucher_detail_list.length>0">
												<a-col :span="8" style="text-align: center;">券类型：{{voucher_type(ali_voucher.type)}}</a-col>
												<a-col :span="8" style="text-align: center;">券名称：￥{{ali_voucher.name}}</a-col>
												<a-col :span="8" style="text-align: center;">优惠券面额：￥{{ali_voucher.amount}}</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;"
											 v-for="order in item.TC_Orders" :key="order.id">
												<a-col :span="2">
													<div style="width: 70px;height: 70px;background-color: #f3f3f5;">
														<img :src="order.sku_cover" width="70" height="70">
													</div>
												</a-col>
												<a-col :span="5" style="text-align: center;position: relative;">
													<div style="text-align: center;">
														<span>{{order.sku_title}}</span><br />
														<span>{{order.sku_properties}}</span><br />
														<a-tag v-if="item.is_solitaire" color="orange" style="margin: 0;">接龙订单</a-tag>
														<a-tag v-if="item.is_solitaire" color="green" style="margin: 0;">{{solitaireStatus(item)}}</a-tag>
													</div>
												</a-col>
												<a-col :span="3" style="text-align: center;">
													<a-tag color="blue" style="margin: 0;" v-if="order.is_match_order">搭配商品</a-tag><br v-if="order.is_match_order">
													<s v-if="item.UIC_User.member_level !==1&&order.original_price&&order.original_price>order.sku_price">￥{{order.original_price/100}}</s>
													<br v-if="item.UIC_User.member_level !==1&&order.original_price&&order.original_price>order.sku_price" />
													￥{{order.sku_price/100}}
												</a-col>
												<a-col :span="2" style="text-align: center;">{{order.amount}}</a-col>
												<a-col :span="2" style="text-align: center;position: relative;">
													<a-popover trigger="hover">
														<template slot="content">
															<p>ID:{{item.UIC_User.id}}</p>
														</template>
														<div style="text-align: center;position: relative;">
															<span style="display: inline-block;width: 100%;word-break: break-all;white-space: normal;">{{item.UIC_User.nick_name}}</span>
															<a-tag color="orange" style="margin: 0;">{{item.UIC_User.member_level==1?'会员':item.UIC_User.member_level==2?'VIP会员':item.UIC_User.member_level==3?'钻石会员':'皇冠会员'}}</a-tag>
														</div>
													</a-popover>
												</a-col>
												<a-col :span="4" style="text-align: center;">
													<span>
														总价：￥ {{order.sku_price*order.amount/100}} <br>
														应付：￥ {{order.receipt_price/100}} <br>
														<span v-if="order.coupon_derate_fee">商品优惠券满减：￥ -{{order.coupon_derate_fee*order.amount/100}}</span>
													</span>
												</a-col>
												<a-col :span="1" />
												<a-col :span="5" style="text-align: center;">
													<div style="text-align: center;" v-if="order.order_status =='finished'">
														<a-button ghost type="danger" size="small" style="width: 96px;margin-bottom: 5px;font-size: 12px;" v-if="!order.is_refund"
														 @click="refund_btn(order,item)">退款</a-button><br />
														<a-button ghost type="danger" size="small" style="width: 96px;margin-bottom: 5px;font-size: 12px;" v-if="order.is_refund"
														 :disabled="true">订单退款中......</a-button><br v-if="order.is_refund" />
													</div>
													<div style="text-align: center;color: #0099FF;font-weight: 700;" v-else-if="order.order_status =='refund'">退款售后</div>
													<div style="text-align: center;color: #0099FF;font-weight: 700;" v-else-if="order.order_status =='closed'">已取消</div>
													<div style="text-align: center;color: #0099FF;font-weight: 700;" v-else-if="order.order_status =='success'">交易成功</div>
												</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
												<a-col :span="3" style="">收件人姓名：{{item.receiver_name}}</a-col>
												<a-col :span="6" style="">收件人手机号码：{{item.receiver_phone}}</a-col>
												<a-col :span="10" style="">地址：{{item.receiver_address}}
													<a-button size="small" type="dashed" shape="circle-outline" icon="copy" @click="copyaddress(item)" />
												</a-col>
												<a-col :span="5" style="text-align: center;">
													<a-button ghost size="small" type="primary" v-if="item.id_card_id" style="width: 96px;font-size: 12px;"
													 @click="changeidcard(item)">身份证信息</a-button>
												</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
												<a-col :span="24">
													<div style="display: inline-block;">买家备注：</div>
													<span>{{item.remarks}}</span>
												</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
												<a-col :span="19">
													<div style="display: inline-block;">运营备注：</div>
													<span>{{item.business_remarks}}</span>
												</a-col>
												<a-col :span="5" style="text-align: center;">
													<a-button ghost size="small" type="primary" style="width: 96px;font-size: 12px;" @click="modify_business_remarks_btn(item)">修改运营备注</a-button>
												</a-col>
											</a-row>
											<div v-for="(express,ind) in item.TC_Delivery_Infos" :key="ind">
												<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
													<a-col :span="5" style="">物流公司：{{express.express_display}}</a-col>
													<a-col :span="5" style="">快递单号：{{express.express_number}}</a-col>
													<a-col :span="9" style="">备注信息：{{express.remarks}}</a-col>
													<a-col :span="5" style="text-align: center;">
														<a-button ghost size="small" type="primary" style="width: 96px;font-size: 12px;" @click="modify_express_number_btn(item,express)">修改单号</a-button>
														<a-button ghost size="small" type="primary" style="width: 96px;font-size: 12px;" @click="query_express_btn(express,false)">查询物流</a-button>
														<!-- <a-button type="primary" size="small" ghost icon="caret-up" v-if="express.query" @click="()=>{express.query = !express.query}" /> -->
														<!-- <a-button type="primary" size="small" ghost icon="caret-down" v-else @click="()=>{express.query = !express.query}" /> -->
													</a-col>
												</a-row>
												<a-row type="flex" justify="space-around" align="middle">
													<a-col v-if="express.query&&express.delivery_info&&express.delivery_info.nu" :span="24" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
														<a-steps direction="vertical" size="small" progressDot>
															<a-step v-for="(info,index) in express.delivery_info.data" :key="index" status="process" :title="info.time"
															 :description="info.context" />
														</a-steps>
													</a-col>
													<a-col v-if="express.query&&(!express.delivery_info||!express.delivery_info.nu)" :span="24" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">暂无信息</a-col>
												</a-row>
											</div>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
												<a-col :span="24" style="text-align: center;">
													<a-button ghost type="primary" size="small" style="width: 96px;margin-bottom: 5px;font-size: 12px;" @click="express_btn(item,item.receiver_phone,item.id_card_id)">发货</a-button>
												</a-col>
											</a-row>
											<a-row v-if="(item.first_agency_id||item.second_agency_id)&&!(item.profitsharing_info||item.profitsharing_fail_info)"
											 type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
												<a-col :span="24">
													<span>该订单含有代理分账：</span>
													<a-button @click="profitsharingquery(item)">查询</a-button>
												</a-col>

											</a-row>
											<a-row v-if="item.profitsharing_info||item.profitsharing_fail_info" type="flex" justify="space-around" align="middle"
											 style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
												<a-col :span="24">
													分账状态提交记录：{{item.is_clear?'已提交':'未提交'}}
												</a-col>
												<a-col :span="4">
													一级代理分账信息：
												</a-col>
												<a-col :span="8">
													{{get_first_info(item)}}
												</a-col>
												<a-col :span="4">
													二级代理分账信息：
												</a-col>
												<a-col :span="8">
													{{get_second_info(item)}}
												</a-col>
											</a-row>
											<a-row v-if="item.profitsharing_fail_info" type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
												<a-col :span="18">
													<span>{{item.profitsharing_fail_info}}</span>
												</a-col>
												<a-col :span="6">
													<a-button @click="profitsharingfinish(item)">尝试完结分账</a-button>
												</a-col>
											</a-row>
											<a-row v-if="item.profitsharing_info" type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
												<a-col :span="24">
													实际分账信息：{{item.profitsharing_info.status}}
												</a-col>
												<a-col :span="8" v-for="(receivers,receiversindex) in item.profitsharing_info.receivers" :key="receiversindex">
													<div v-if="receivers.type == 'MERCHANT_ID'">
														{{receivers.description}},金额￥:{{receivers.amount/100}}
													</div>
													<div v-if="receivers.type == 'PERSONAL_OPENID'">
														账户:{{receivers.user_id}},实际分账金额￥:{{receivers.amount/100}}
													</div>
												</a-col>
											</a-row>
										</div>
									</div>
									<div style="float: right;position: relative;bottom: -18px;">
										<a-pagination showSizeChanger @showSizeChange="onShowSizeChange" :current="endpage/pageSize" :pageSize="pageSize"
										 :total="tradesum" showQuickJumper @change="pageChange" />
									</div>
								</div>
							</a-tab-pane>
							<a-tab-pane tab="交易成功" key="success">
								<div style="padding-bottom: 50px;">
									<div style="display: flow-root;position: relative;margin-bottom: 10px;">
										<a-button type="primary" style="width: 96px;" :disabled="!tradelist.length" @click="exportexcel">导出Excel</a-button>
										<a-button type="primary" @click="link_to" style="float: right;">编辑发货短信模板</a-button>
									</div>
									<div>
										<div v-if="issearch" style="text-align: center;background: rgba(0,0,0,0.05);border-radius: 4px;margin-bottom: 20px;padding: 30px 50px;margin: 20px 0;">
											<a-spin />
										</div>
										<div v-if="(!tradelist.length)&&(!issearch)">
											<a-alert message="查询结果为空" banner type="info" />
										</div>
										<div v-if="tradelist.length">
											<a-row type="flex" justify="space-around" align="middle" style="background-color: #f3f3f5;font-size: 14px;height: 60px;font-weight: 700;">
												<a-col :span="8" style="text-align: center;">商品名称</a-col>
												<a-col :span="3" style="text-align: center;">单价</a-col>
												<a-col :span="2" style="text-align: center;">数量</a-col>
												<a-col :span="2" style="text-align: center;">买家</a-col>
												<a-col :span="4" style="text-align: center;">订单总金额</a-col>
												<!-- <a-col :span="6" style="text-align: center;">状态</a-col> -->
											</a-row>
										</div>
										<div style="color: #666;font-size: 14px;margin-bottom: 20px;" v-for="item in tradelist" :key="item.id">
											<a-row type="flex" justify="space-around" align="middle" style="font-weight: 600;border: #e8e8e8 solid 1px;height: 30px;line-height: 30px;">
												<a-col :span="9" style="text-align: center;">
													<a-tag color="blue" v-if="item.is_cainiao">当日达</a-tag>订单号：{{item.trade_number}}
												</a-col>
												<a-col :span="3" style="text-align: center;">运费：￥{{item.delivery_fee/100}}</a-col>
												<a-col :span="3" style="text-align: center;">订单实付：￥{{item.receipt_price/100}}</a-col>
												<a-col :span="5" style="text-align: center;">创建时间：{{moment(item.created_at).format("YYYY-MM-DD HH:mm:ss")}}</a-col>
												<a-col :span="4" style="text-align: center;" v-if="item.trade_platform==1">订单提交平台：微信</a-col>
												<a-col :span="4" style="text-align: center;" v-if="item.trade_platform==2">订单提交平台：Excel</a-col>
												<a-col :span="4" style="text-align: center;" v-if="item.trade_platform==3">订单提交平台：支付宝</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px;height: 30px;line-height: 30px;border-top: 0px;" v-if="item.is_match_trade">
												<a-col :span="24" style="text-align: center;">该订单为搭配商品购买订单，请注意退款及取消订单相关操作</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px;height: 30px;line-height: 30px;border-top: 0px;" v-if="item.coupon_derate_fee">
												<a-col :span="8" style="text-align: center;">券类型：全店优惠券</a-col>
												<a-col :span="8" style="text-align: center;">券名称：{{item.coupon_card_title}}</a-col>
												<a-col :span="8" style="text-align: center;">优惠券面额：￥{{item.coupon_derate_fee/100}}</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px;height: 30px;line-height: 30px;border-top: 0px;"
											 v-for="(ali_voucher,ali_voucher_index) in item.ali_voucher_detail_list" :key="ali_voucher_index" v-if="item.ali_voucher_detail_list.length>0">
												<a-col :span="8" style="text-align: center;">券类型：{{voucher_type(ali_voucher.type)}}</a-col>
												<a-col :span="8" style="text-align: center;">券名称：￥{{ali_voucher.name}}</a-col>
												<a-col :span="8" style="text-align: center;">优惠券面额：￥{{ali_voucher.amount}}</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;"
											 v-for="order in item.TC_Orders" :key="order.id">
												<a-col :span="2">
													<div style="width: 70px;height: 70px;background-color: #f3f3f5;">
														<img :src="order.sku_cover" width="70" height="70">
													</div>
												</a-col>
												<a-col :span="5" style="text-align: center;position: relative;">
													<div style="text-align: center;">
														<span>{{order.sku_title}}</span><br />
														<span>{{order.sku_properties}}</span><br />
														<a-tag v-if="item.is_solitaire" color="orange" style="margin: 0;">接龙订单</a-tag>
														<a-tag v-if="item.is_solitaire" color="green" style="margin: 0;">{{solitaireStatus(item)}}</a-tag>
													</div>
												</a-col>
												<a-col :span="3" style="text-align: center;">
													<a-tag color="blue" style="margin: 0;" v-if="order.is_match_order">搭配商品</a-tag><br v-if="order.is_match_order">
													<s v-if="item.UIC_User.member_level !==1&&order.original_price&&order.original_price>order.sku_price">￥{{order.original_price/100}}</s>
													<br v-if="item.UIC_User.member_level !==1&&order.original_price&&order.original_price>order.sku_price" />
													￥{{order.sku_price/100}}
												</a-col>
												<a-col :span="2" style="text-align: center;">{{order.amount}}</a-col>
												<a-col :span="2" style="text-align: center;position: relative;">
													<a-popover trigger="hover">
														<template slot="content">
															<p>ID:{{item.UIC_User.id}}</p>
														</template>
														<div style="text-align: center;position: relative;">
															<span style="display: inline-block;width: 100%;word-break: break-all;white-space: normal;">{{item.UIC_User.nick_name}}</span>
															<a-tag color="orange" style="margin: 0;">{{item.UIC_User.member_level==1?'会员':item.UIC_User.member_level==2?'VIP会员':item.UIC_User.member_level==3?'钻石会员':'皇冠会员'}}</a-tag>
														</div>
													</a-popover>
												</a-col>
												<a-col :span="4" style="text-align: center;">
													<span>
														总价：￥ {{order.sku_price*order.amount/100}} <br>
														应付：￥ {{order.receipt_price/100}} <br>
														<span v-if="order.coupon_derate_fee">商品优惠券满减：￥ -{{order.coupon_derate_fee*order.amount/100}}</span>
													</span>
												</a-col>
												<!-- <a-col :span="6" style="text-align: center;color: #0099FF;font-weight: 700;">{{status[order.order_status]}}</a-col> -->
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
												<a-col :span="3" style="">收件人姓名：{{item.receiver_name}}</a-col>
												<a-col :span="6" style="">收件人手机号码：{{item.receiver_phone}}</a-col>
												<a-col :span="10" style="">地址：{{item.receiver_address}}
													<a-button size="small" type="dashed" shape="circle-outline" icon="copy" @click="copyaddress(item)" />
												</a-col>
												<a-col :span="5" style="text-align: center;">
													<a-button ghost size="small" type="primary" v-if="item.id_card_id" style="width: 96px;font-size: 12px;"
													 @click="changeidcard(item)">身份证信息</a-button>
												</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
												<a-col :span="24">
													<div style="display: inline-block;">买家备注：</div>
													<span>{{item.remarks}}</span>
												</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
												<a-col :span="19">
													<div style="display: inline-block;">运营备注：</div>
													<span>{{item.business_remarks}}</span>
												</a-col>
												<a-col :span="5" style="text-align: center;">
													<a-button ghost size="small" type="primary" style="width: 96px;font-size: 12px;" @click="modify_business_remarks_btn(item)">修改运营备注</a-button>
												</a-col>
											</a-row>
											<div v-for="(express,ind) in item.TC_Delivery_Infos" :key="ind">
												<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
													<a-col :span="5" style="">物流公司：{{express.express_display}}</a-col>
													<a-col :span="5" style="">快递单号：{{express.express_number}}</a-col>
													<a-col :span="9" style="">备注信息：{{express.remarks}}</a-col>
													<a-col :span="5" style="text-align: center;">
														<a-button ghost size="small" type="primary" style="width: 96px;font-size: 12px;" @click="modify_express_number_btn(item,express)">修改单号</a-button>
														<a-button ghost size="small" type="primary" style="width: 96px;font-size: 12px;" @click="query_express_btn(express,false)">查询物流</a-button>
														<!-- <a-button type="primary" size="small" ghost icon="caret-up" v-if="express.query" @click="()=>{express.query = !express.query}" /> -->
														<!-- <a-button type="primary" size="small" ghost icon="caret-down" v-else @click="()=>{express.query = !express.query}" /> -->
													</a-col>
												</a-row>
												<a-row type="flex" justify="space-around" align="middle">
													<a-col v-if="express.query&&express.delivery_info&&express.delivery_info.nu" :span="24" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
														<a-steps direction="vertical" size="small" progressDot>
															<a-step v-for="(info,index) in express.delivery_info.data" :key="index" status="process" :title="info.time"
															 :description="info.context" />
														</a-steps>
													</a-col>
													<a-col v-if="express.query&&(!express.delivery_info||!express.delivery_info.nu)" :span="24" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">暂无信息</a-col>
												</a-row>
											</div>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
												<a-col :span="24" style="text-align: center;">
													<a-button ghost type="primary" size="small" style="width: 96px;margin-bottom: 5px;font-size: 12px;" @click="express_btn(item,item.receiver_phone,item.id_card_id)">发货</a-button>
												</a-col>
											</a-row>
											<a-row v-if="(item.first_agency_id||item.second_agency_id)&&!(item.profitsharing_info||item.profitsharing_fail_info)"
											 type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
												<a-col :span="24">
													<span>该订单含有代理分账：</span>
													<a-button @click="profitsharingquery(item)">查询</a-button>
												</a-col>

											</a-row>
											<a-row v-if="item.profitsharing_info||item.profitsharing_fail_info" type="flex" justify="space-around" align="middle"
											 style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
												<a-col :span="24">
													分账状态提交记录：{{item.is_clear?'已提交':'未提交'}}
												</a-col>
												<a-col :span="4">
													一级代理分账信息：
												</a-col>
												<a-col :span="8">
													{{get_first_info(item)}}
												</a-col>
												<a-col :span="4">
													二级代理分账信息：
												</a-col>
												<a-col :span="8">
													{{get_second_info(item)}}
												</a-col>
											</a-row>
											<a-row v-if="item.profitsharing_fail_info" type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
												<a-col :span="18">
													<span>{{item.profitsharing_fail_info}}</span>
												</a-col>
												<a-col :span="6">
													<a-button @click="profitsharingfinish(item)">尝试完结分账</a-button>
												</a-col>
											</a-row>
											<a-row v-if="item.profitsharing_info" type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
												<a-col :span="24">
													实际分账信息：{{item.profitsharing_info.status}}
												</a-col>
												<a-col :span="8" v-for="(receivers,receiversindex) in item.profitsharing_info.receivers" :key="receiversindex">
													<div v-if="receivers.type == 'MERCHANT_ID'">
														{{receivers.description}},金额￥:{{receivers.amount/100}}
													</div>
													<div v-if="receivers.type == 'PERSONAL_OPENID'">
														账户:{{receivers.user_id}},实际分账金额￥:{{receivers.amount/100}}
													</div>
												</a-col>
											</a-row>
										</div>
									</div>
									<div style="float: right;position: relative;bottom: -18px;">
										<a-pagination showSizeChanger @showSizeChange="onShowSizeChange" :current="endpage/pageSize" :pageSize="pageSize"
										 :total="tradesum" showQuickJumper @change="pageChange" />
									</div>
								</div>
							</a-tab-pane>
							<a-tab-pane tab="申请退款售后" key="refund">
								<div style="padding-bottom: 50px;">
									<div style="display: flow-root;position: relative;margin-bottom: 10px;">
										<a-button type="primary" style="width: 96px;" :disabled="!tradelist.length" @click="exportexcel">导出Excel</a-button>
										<a-button type="primary" @click="link_to" style="float: right;">编辑发货短信模板</a-button>
									</div>
									<div>
										<div v-if="issearch" style="text-align: center;background: rgba(0,0,0,0.05);border-radius: 4px;margin-bottom: 20px;padding: 30px 50px;margin: 20px 0;">
											<a-spin />
										</div>
										<div v-if="(!tradelist.length)&&(!issearch)">
											<a-alert message="查询结果为空" banner type="info" />
										</div>
										<div v-if="tradelist.length">
											<a-row type="flex" justify="space-around" align="middle" style="background-color: #f3f3f5;font-size: 14px;height: 60px;font-weight: 700;">
												<a-col :span="7" style="text-align: center;">商品名称</a-col>
												<a-col :span="3" style="text-align: center;">单价</a-col>
												<a-col :span="2" style="text-align: center;">数量</a-col>
												<a-col :span="2" style="text-align: center;">买家</a-col>
												<a-col :span="4" style="text-align: center;">订单总金额</a-col>
												<a-col :span="6" style="text-align: center;">操作</a-col>
											</a-row>
										</div>
										<div style="color: #666;font-size: 14px;margin-bottom: 20px;" v-for="item in tradelist" :key="item.id">
											<a-row type="flex" justify="space-around" align="middle" style="font-weight: 600;border: #e8e8e8 solid 1px;height: 30px;line-height: 30px;">
												<a-col :span="9" style="text-align: center;">
													<a-tag color="blue" v-if="item.is_cainiao">当日达</a-tag>订单号：{{item.trade_number}}
												</a-col>
												<a-col :span="3" style="text-align: center;">运费：￥{{item.delivery_fee/100}}</a-col>
												<a-col :span="3" style="text-align: center;">订单实付：￥{{item.receipt_price/100}}</a-col>
												<a-col :span="5" style="text-align: center;">创建时间：{{moment(item.created_at).format("YYYY-MM-DD HH:mm:ss")}}</a-col>
												<a-col :span="4" style="text-align: center;" v-if="item.trade_platform==1">订单提交平台：微信</a-col>
												<a-col :span="4" style="text-align: center;" v-if="item.trade_platform==2">订单提交平台：Excel</a-col>
												<a-col :span="4" style="text-align: center;" v-if="item.trade_platform==3">订单提交平台：支付宝</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px;height: 30px;line-height: 30px;border-top: 0px;" v-if="item.is_match_trade">
												<a-col :span="24" style="text-align: center;">该订单为搭配商品购买订单，请注意退款及取消订单相关操作</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px;height: 30px;line-height: 30px;border-top: 0px;" v-if="item.coupon_derate_fee">
												<a-col :span="8" style="text-align: center;">券类型：全店优惠券</a-col>
												<a-col :span="8" style="text-align: center;">券名称：{{item.coupon_card_title}}</a-col>
												<a-col :span="8" style="text-align: center;">优惠券面额：￥{{item.coupon_derate_fee/100}}</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px;height: 30px;line-height: 30px;border-top: 0px;"
											 v-for="(ali_voucher,ali_voucher_index) in item.ali_voucher_detail_list" :key="ali_voucher_index" v-if="item.ali_voucher_detail_list.length>0">
												<a-col :span="8" style="text-align: center;">券类型：{{voucher_type(ali_voucher.type)}}</a-col>
												<a-col :span="8" style="text-align: center;">券名称：￥{{ali_voucher.name}}</a-col>
												<a-col :span="8" style="text-align: center;">优惠券面额：￥{{ali_voucher.amount}}</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;"
											 v-for="order in item.TC_Orders" :key="order.id">
												<a-col :span="2">
													<div style="width: 70px;height: 70px;background-color: #f3f3f5;">
														<img :src="order.sku_cover" width="70" height="70">
													</div>
												</a-col>
												<a-col :span="5" style="text-align: center;position: relative;">
													<div style="text-align: center;">
														<span>{{order.sku_title}}</span><br />
														<span>{{order.sku_properties}}</span><br />
														<a-tag v-if="item.is_solitaire" color="orange" style="margin: 0;">接龙订单</a-tag>
														<a-tag v-if="item.is_solitaire" color="green" style="margin: 0;">{{solitaireStatus(item)}}</a-tag>
													</div>
												</a-col>
												<a-col :span="3" style="text-align: center;">
													<a-tag color="blue" style="margin: 0;" v-if="order.is_match_order">搭配商品</a-tag><br v-if="order.is_match_order">
													<s v-if="item.UIC_User.member_level !==1&&order.original_price&&order.original_price>order.sku_price">￥{{order.original_price/100}}</s>
													<br v-if="item.UIC_User.member_level !==1&&order.original_price&&order.original_price>order.sku_price" />
													￥{{order.sku_price/100}}
												</a-col>
												<a-col :span="2" style="text-align: center;">{{order.amount}}</a-col>
												<a-col :span="2" style="text-align: center;position: relative;">
													<a-popover trigger="hover">
														<template slot="content">
															<p>ID:{{item.UIC_User.id}}</p>
														</template>
														<div style="text-align: center;position: relative;">
															<span style="display: inline-block;width: 100%;word-break: break-all;white-space: normal;">{{item.UIC_User.nick_name}}</span>
															<a-tag color="orange" style="margin: 0;">{{item.UIC_User.member_level==1?'会员':item.UIC_User.member_level==2?'VIP会员':item.UIC_User.member_level==3?'钻石会员':'皇冠会员'}}</a-tag>
														</div>
													</a-popover>
												</a-col>
												<a-col :span="4" style="text-align: center;">
													<span>
														总价：￥ {{order.sku_price*order.amount/100}} <br>
														应付：￥ {{order.receipt_price/100}} <br>
														<span v-if="order.coupon_derate_fee">商品优惠券满减：￥ -{{order.coupon_derate_fee*order.amount/100}}</span>
													</span>
												</a-col>
												<a-col :span="1" />
												<a-col :span="5" style="text-align: center;">
													<div style="text-align: center;" v-if="order.order_status =='refund'">
														<a-button ghost type="danger" size="small" style="width: 96px;margin-bottom: 5px;font-size: 12px;" v-if="!order.is_refund"
														 @click="refund_btn(order,item)">退款</a-button><br />
														<a-button ghost type="danger" size="small" style="width: 96px;margin-bottom: 5px;font-size: 12px;" v-if="order.is_refund"
														 :disabled="true">订单退款中......</a-button><br v-if="order.is_refund" />
														<a-button ghost type="danger" size="small" style="width: 96px;font-size: 12px;color: #ffc300;border-color: #ffc300;"
														 @click="reject_refund_btn(order)">驳回退款</a-button>
													</div>
													<div style="text-align: center;color: #0099FF;font-weight: 700;" v-else>退款售后中</div>
												</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
												<a-col :span="3" style="">收件人姓名：{{item.receiver_name}}</a-col>
												<a-col :span="6" style="">收件人手机号码：{{item.receiver_phone}}</a-col>
												<a-col :span="10" style="">地址：{{item.receiver_address}}
													<a-button size="small" type="dashed" shape="circle-outline" icon="copy" @click="copyaddress(item)" />
												</a-col>
												<a-col :span="5" style="text-align: center;">
													<a-button ghost size="small" type="primary" v-if="item.id_card_id" style="width: 96px;font-size: 12px;"
													 @click="changeidcard(item)">身份证信息</a-button>
												</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
												<a-col :span="24">
													<div style="display: inline-block;">买家备注：</div>
													<span>{{item.remarks}}</span>
												</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
												<a-col :span="19">
													<div style="display: inline-block;">运营备注：</div>
													<span>{{item.business_remarks}}</span>
												</a-col>
												<a-col :span="5" style="text-align: center;">
													<a-button ghost size="small" type="primary" style="width: 96px;font-size: 12px;" @click="modify_business_remarks_btn(item)">修改运营备注</a-button>
												</a-col>
											</a-row>
											<div v-for="(express,ind) in item.TC_Delivery_Infos" :key="ind">
												<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
													<a-col :span="5" style="">物流公司：{{express.express_display}}</a-col>
													<a-col :span="5" style="">快递单号：{{express.express_number}}</a-col>
													<a-col :span="9" style="">备注信息：{{express.remarks}}</a-col>
													<a-col :span="5" style="text-align: center;">
														<!-- <a-button ghost size="small" type="primary" style="width: 96px;font-size: 12px;" @click="modify_express_number_btn(item,express)">修改单号</a-button> -->
														<a-button ghost size="small" type="primary" style="width: 96px;font-size: 12px;" @click="query_express_btn(express,true)">查询物流</a-button>
														<!-- <a-button type="primary" size="small" ghost icon="caret-up" v-if="express.query" @click="()=>{express.query = !express.query}" /> -->
														<!-- <a-button type="primary" size="small" ghost icon="caret-down" v-else @click="()=>{express.query = !express.query}" /> -->
													</a-col>
												</a-row>
												<a-row type="flex" justify="space-around" align="middle">
													<a-col v-if="express.query&&express.delivery_info&&express.delivery_info.nu" :span="24" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
														<a-steps direction="vertical" size="small" progressDot>
															<a-step v-for="(info,index) in express.delivery_info.data" :key="index" status="process" :title="info.time"
															 :description="info.context" />
														</a-steps>
													</a-col>
													<a-col v-if="express.query&&(!express.delivery_info||!express.delivery_info.nu)" :span="24" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">暂无信息</a-col>
												</a-row>
											</div>
										</div>
									</div>
									<div style="float: right;position: relative;bottom: -18px;">
										<a-pagination showSizeChanger @showSizeChange="onShowSizeChange" :current="endpage/pageSize" :pageSize="pageSize"
										 :total="tradesum" showQuickJumper @change="pageChange" />
									</div>
								</div>
							</a-tab-pane>
							<a-tab-pane tab="已取消" key="closed">
								<div style="padding-bottom: 50px;">
									<div style="display: flow-root;position: relative;margin-bottom: 10px;">
										<a-button type="primary" style="width: 96px;" :disabled="!tradelist.length" @click="exportexcel">导出Excel</a-button>
										<a-button type="primary" @click="link_to" style="float: right;">编辑发货短信模板</a-button>
									</div>
									<div>
										<div v-if="issearch" style="text-align: center;background: rgba(0,0,0,0.05);border-radius: 4px;margin-bottom: 20px;padding: 30px 50px;margin: 20px 0;">
											<a-spin />
										</div>
										<div v-if="(!tradelist.length)&&(!issearch)">
											<a-alert message="查询结果为空" banner type="info" />
										</div>
										<div v-if="tradelist.length">
											<a-row type="flex" justify="space-around" align="middle" style="background-color: #f3f3f5;font-size: 14px;height: 60px;font-weight: 700;">
												<a-col :span="8" style="text-align: center;">商品名称</a-col>
												<a-col :span="3" style="text-align: center;">单价</a-col>
												<a-col :span="2" style="text-align: center;">数量</a-col>
												<a-col :span="2" style="text-align: center;">买家</a-col>
												<a-col :span="4" style="text-align: center;">订单总金额</a-col>
												<!-- <a-col :span="6" style="text-align: center;">状态</a-col> -->
											</a-row>
										</div>
										<div style="color: #666;font-size: 14px;margin-bottom: 20px;" v-for="item in tradelist" :key="item.id">
											<a-row type="flex" justify="space-around" align="middle" style="font-weight: 600;border: #e8e8e8 solid 1px;height: 30px;line-height: 30px;">
												<a-col :span="9" style="text-align: center;">
													<a-tag color="blue" v-if="item.is_cainiao">当日达</a-tag>订单号：{{item.trade_number}}
												</a-col>
												<a-col :span="3" style="text-align: center;">运费：￥{{item.delivery_fee/100}}</a-col>
												<a-col :span="3" style="text-align: center;">订单实付：￥{{item.receipt_price/100}}</a-col>
												<a-col :span="5" style="text-align: center;">创建时间：{{moment(item.created_at).format("YYYY-MM-DD HH:mm:ss")}}</a-col>
												<a-col :span="4" style="text-align: center;" v-if="item.trade_platform==1">订单提交平台：微信</a-col>
												<a-col :span="4" style="text-align: center;" v-if="item.trade_platform==2">订单提交平台：Excel</a-col>
												<a-col :span="4" style="text-align: center;" v-if="item.trade_platform==3">订单提交平台：支付宝</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px;height: 30px;line-height: 30px;border-top: 0px;" v-if="item.is_match_trade">
												<a-col :span="24" style="text-align: center;">该订单为搭配商品购买订单，请注意退款及取消订单相关操作</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px;height: 30px;line-height: 30px;border-top: 0px;" v-if="item.coupon_derate_fee">
												<a-col :span="8" style="text-align: center;">券类型：全店优惠券</a-col>
												<a-col :span="8" style="text-align: center;">券名称：{{item.coupon_card_title}}</a-col>
												<a-col :span="8" style="text-align: center;">优惠券面额：￥{{item.coupon_derate_fee/100}}</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px;height: 30px;line-height: 30px;border-top: 0px;"
											 v-for="(ali_voucher,ali_voucher_index) in item.ali_voucher_detail_list" :key="ali_voucher_index" v-if="item.ali_voucher_detail_list.length>0">
												<a-col :span="8" style="text-align: center;">券类型：{{voucher_type(ali_voucher.type)}}</a-col>
												<a-col :span="8" style="text-align: center;">券名称：￥{{ali_voucher.name}}</a-col>
												<a-col :span="8" style="text-align: center;">优惠券面额：￥{{ali_voucher.amount}}</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;"
											 v-for="order in item.TC_Orders" :key="order.id">
												<a-col :span="2">
													<div style="width: 70px;height: 70px;background-color: #f3f3f5;">
														<img :src="order.sku_cover" width="70" height="70">
													</div>
												</a-col>
												<a-col :span="5" style="text-align: center;position: relative;">
													<div style="text-align: center;">
														<span>{{order.sku_title}}</span><br />
														<span>{{order.sku_properties}}</span><br />
														<a-tag v-if="item.is_solitaire" color="orange" style="margin: 0;">接龙订单</a-tag>
														<a-tag v-if="item.is_solitaire" color="green" style="margin: 0;">{{solitaireStatus(item)}}</a-tag>
													</div>
												</a-col>
												<a-col :span="3" style="text-align: center;">
													<a-tag color="blue" style="margin: 0;" v-if="order.is_match_order">搭配商品</a-tag><br v-if="order.is_match_order">
													<s v-if="item.UIC_User.member_level !==1&&order.original_price&&order.original_price>order.sku_price">￥{{order.original_price/100}}</s>
													<br v-if="item.UIC_User.member_level !==1&&order.original_price&&order.original_price>order.sku_price" />
													￥{{order.sku_price/100}}
												</a-col>
												<a-col :span="2" style="text-align: center;">{{order.amount}}</a-col>
												<a-col :span="2" style="text-align: center;position: relative;">
													<a-popover trigger="hover">
														<template slot="content">
															<p>ID:{{item.UIC_User.id}}</p>
														</template>
														<div style="text-align: center;position: relative;">
															<span style="display: inline-block;width: 100%;word-break: break-all;white-space: normal;">{{item.UIC_User.nick_name}}</span>
															<a-tag color="orange" style="margin: 0;">{{item.UIC_User.member_level==1?'会员':item.UIC_User.member_level==2?'VIP会员':item.UIC_User.member_level==3?'钻石会员':'皇冠会员'}}</a-tag>
														</div>
													</a-popover>
												</a-col>
												<a-col :span="4" style="text-align: center;">
													<span>
														总价：￥ {{order.sku_price*order.amount/100}} <br>
														应付：￥ {{order.receipt_price/100}} <br>
														<span v-if="order.coupon_derate_fee">商品优惠券满减：￥ -{{order.coupon_derate_fee*order.amount/100}}</span>
													</span>
												</a-col>
												<!-- <a-col :span="6" style="text-align: center;color: #0099FF;font-weight: 700;">{{status[order.order_status]}}</a-col> -->
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
												<a-col :span="3" style="">收件人姓名：{{item.receiver_name}}</a-col>
												<a-col :span="6" style="">收件人手机号码：{{item.receiver_phone}}</a-col>
												<a-col :span="10" style="">地址：{{item.receiver_address}}
													<a-button size="small" type="dashed" shape="circle-outline" icon="copy" @click="copyaddress(item)" />
												</a-col>
												<a-col :span="5" style="text-align: center;">
													<a-button ghost size="small" type="primary" v-if="item.id_card_id" style="width: 96px;font-size: 12px;"
													 @click="changeidcard(item)">身份证信息</a-button>
												</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
												<a-col :span="24">
													<div style="display: inline-block;">买家备注：</div>
													<span>{{item.remarks}}</span>
												</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
												<a-col :span="19">
													<div style="display: inline-block;">运营备注：</div>
													<span>{{item.business_remarks}}</span>
												</a-col>
												<a-col :span="5" style="text-align: center;">
													<a-button ghost size="small" type="primary" style="width: 96px;font-size: 12px;" @click="modify_business_remarks_btn(item)">修改运营备注</a-button>
												</a-col>
											</a-row>
										</div>
									</div>
									<div style="float: right;position: relative;bottom: -18px;">
										<a-pagination showSizeChanger @showSizeChange="onShowSizeChange" :current="endpage/pageSize" :pageSize="pageSize"
										 :total="tradesum" showQuickJumper @change="pageChange" />
									</div>
								</div>
							</a-tab-pane>
						</a-tabs>
					</div>
				</a-layout-content>
				<bottomBar></bottomBar>
			</a-layout>
		</a-layout>
		<div>
			<a-back-top />
		</div>

		<a-modal title="编辑身份证" :width="1000" :visible="id_card_visible" @ok="id_card_Ok" :confirmLoading="confirmLoading"
		 @cancel="id_card_Cancel">
			<div style="text-align: center;">
				<canvas id="idimg" style="width: 50%; display: inline-block;" />
			</div>
			<div style="text-align: center;">
				<div style="margin: 10px 0;"><span style="display: inline-block; width: 100px;text-align: right;">姓名:</span>
					<a-input style="width: 250px;" v-model="id_card_info.real_name" placeholder="请输入姓名" />
				</div>
				<div><span style="display: inline-block; width: 100px;text-align: right;">身份证号:</span>
					<a-input style="width: 250px;" v-model="id_card_info.id_card" placeholder="请输入身份证号" />
				</div>
			</div>
		</a-modal>

		<a-modal title="发货" :width="600" :visible="express_visible" @ok="express_Ok" :confirmLoading="expressLoading" @cancel="express_Cancel">
			<div>
				<div style="margin: 10px 0;margin-left: 80px;"><span style="display: inline-block; width: 100px;text-align: right;margin-right: 20px;">联系方式</span>
					<a-input style="width: 250px;" v-model="express_info.phone_number" placeholder="请输入电话号码" @change="phone_number_change" />
				</div>
				<div style="margin: 10px 0;margin-left: 80px;"><span style="display: inline-block; width: 100px;text-align: right;margin-right: 20px;">物流公司</span>
					<a-select showSearch :filterOption="filterOption" :value="express_info.express_name" placeholder="请选择物流公司" style="width: 250px"
					 @change="expressChange">
						<a-select-option :value="item.express_name" v-for="item in express_data" :key="item.express_display">{{item.express_display}}</a-select-option>
					</a-select>
				</div>
				<div style="margin: 10px 0;margin-left: 80px;"><span style="display: inline-block; width: 100px;text-align: right;margin-right: 20px;">物流单号</span>
					<a-input style="width: 250px;" v-model.trim="express_info.express_number" placeholder="请输入物流单号" @change="express_number_change" />
				</div>
				<div style="margin: 10px 0;margin-left: 80px;"><span style="display: inline-block; width: 100px;text-align: right;margin-right: 20px;">备注</span>
					<a-input style="width: 250px;" v-model="express_info.remarks" placeholder="请输入备注" />
				</div>
				<div style="margin: 10px 0;margin-left: 80px;"><span style="display: inline-block; width: 100px;text-align: right;margin-right: 20px;">包裹中货物</span>
					<a-select style="width: 250px" mode="multiple" v-model="express_info.order_list" @change="order_list_change">
						<a-select-option v-for="order in temp_order_list" :key="order.id">
							<a-icon type="check-circle" style="color: green;" v-if="order.order_status=='delivery'" />
							{{order.sku_title}}
						</a-select-option>
					</a-select>
				</div>
				<div style="margin: 10px 0;margin-left: 80px;" v-if="express_info.id_card_id"><span style="display: inline-block; width: 100px;text-align: right;margin-right: 20px;">同步身份证选项</span>
					<a-checkbox-group @change="onChangeIdCard" style="width: 250px;">
						<a-row>
							<a-col :span="8">
								<a-checkbox value="ewe">EWE</a-checkbox>
							</a-col>
						</a-row>
					</a-checkbox-group>
				</div>
				<div style="margin: 10px 0;margin-left: 60px;"><span style="display: inline-block; width: 120px;text-align: right;margin-right: 20px;">发送物流跟踪短信</span>
					<a-switch v-model="express_info.send_express_massage" style="margin-right: 20px;" />
				</div>
				<div style="margin: 10px 0;margin-left: 60px;"><span style="display: inline-block; width: 120px;text-align: right;margin-right: 20px;">发送发货通知短信</span>
					<a-switch v-model="express_info.send_massage" style="margin-right: 20px;" />
					<a-select :value="express_info.massage_id" placeholder="请选择短信模板" style="width: 200px;" :disabled="!express_info.send_massage"
					 @change="note_change">
						<a-select-option :value="note.id" v-for="note in notetemplatelist" :key="note.id">{{note.note_title}}</a-select-option>
					</a-select>
				</div>
				<div style="margin: 10px 0;" v-if="express_info.send_massage">
					<a-input v-model="express_info.massage_info" type="textarea" rows="4" placeholder="请输入内容"></a-input>
				</div>

			</div>
		</a-modal>

		<a-modal title="退款" :visible="refund_visible" @ok="refund_Ok" :confirmLoading="refundLoading" @cancel="refund_Cancel">
			<div style="">
				<div style="margin: 10px 0;"><span style="display: inline-block; width: 120px;text-align: right;margin-right: 20px;">可退金额</span>
					<a-input-number v-model="refund_info.can_be_refund_fee" :formatter="value => `￥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
					 :parser="value => value.replace(/\$\s?|(,*)/g, '')" style="width: 250px;" disabled />
				</div>
				<div style="margin: 10px 0;"><span style="display: inline-block; width: 120px;text-align: right;margin-right: 20px;">退款金额</span>
					<a-input-number :max="refund_info.can_be_refund_fee" :min="0" v-model="refund_info.refund_fee" :formatter="value => `￥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
					 style="width: 250px;" />
				</div>
				<div style="margin: 10px 0;"><span style="display: inline-block; width: 120px;text-align: right;margin-right: 20px;">退款理由</span>
					<a-input style="width: 250px;" v-model="refund_info.remark" placeholder="请输入退款理由" />
				</div>
				<div style="margin: 10px 0;"><span style="display: inline-block; width: 120px;text-align: right;margin-right: 20px;">是否有退货</span>
					<a-switch checkedChildren="有" unCheckedChildren="无" v-model="refund_info.have_express" />
				</div>
				<div style="margin: 10px 0;"><span style="display: inline-block; width: 120px;text-align: right;margin-right: 20px;">提交api退款</span>
					<a-switch checkedChildren="是" unCheckedChildren="否" v-model="refund_info.auto_refund" />
				</div>
				<!-- <div style="margin: 10px 0;"><span style="display: inline-block; width: 120px;text-align: right;margin-right: 20px;">是否退款运费(请确认此次退款为本交易最后一次退款)</span>
					<a-switch checkedChildren="是" unCheckedChildren="否" v-model="refund_info.refund_express_fee" />
				</div> -->
			</div>
		</a-modal>

		<a-modal title="修改地址" :visible="address_visible" @ok="address_Ok" :confirmLoading="addressLoading" @cancel="address_Cancel">
			<div style="">
				<div style="margin: 10px 0;"><span style="display: inline-block; width: 100px;text-align: right;margin-right: 20px;">收件人姓名</span>
					<a-input style="width: 250px;" v-model="address_info.receiver_name" placeholder="请输入收件人姓名" />
				</div>
				<div style="margin: 10px 0;"><span style="display: inline-block; width: 100px;text-align: right;margin-right: 20px;">收件人手机号码</span>
					<a-input style="width: 250px;" v-model="address_info.receiver_phone" placeholder="请输入收件人手机号码" />
				</div>
				<div style="margin: 10px 0;"><span style="display: inline-block; width: 100px;text-align: right;margin-right: 20px;">收件人地址</span>
					<a-input style="width: 250px;" v-model="address_info.receiver_address" placeholder="请输入收件人地址" />
				</div>
			</div>
		</a-modal>

		<a-modal title="修改价格" :visible="price_visible" @ok="price_Ok" :confirmLoading="priceLoading" @cancel="price_Cancel">
			<div style="">
				<div style="margin: 10px 0;"><span style="display: inline-block; width: 100px;text-align: right;margin-right: 20px;">商品单价</span>
					<a-input style="width: 250px;" v-model="modify_price.order_sku_price" placeholder="请输入商品单价" @change="modify_sku_price" />
				</div>
				<div style="margin: 10px 0;"><span style="display: inline-block; width: 100px;text-align: right;margin-right: 20px;">商品总价</span>
					<a-input style="width: 250px;" v-model="modify_price.order_receipt_price" placeholder="请输入商品总价" />
				</div>
				<div style="margin: 10px 0;"><span style="display: inline-block; width: 100px;text-align: right;margin-right: 20px;">修改备注</span>
					<a-input style="width: 250px;" v-model="modify_price.remarks" placeholder="请输入修改备注" />
				</div>
			</div>
		</a-modal>


		<a-modal title="修改运营备注" :visible="business_remarks_visible" @ok="business_remarks_Ok" :confirmLoading="businessRemarksLoading"
		 @cancel="business_remarks_Cancel">
			<a-input style="width: 100%;" v-model="business_remarks.business_remarks" type="textarea" rows="4" placeholder="请输入运营备注" />
		</a-modal>

	</div>
</template>

<script>
	import moment from 'moment';
	import $ from 'jquery';
	import AddressParse from 'address-parse';
	import * as math from "mathjs/lib/cjs"

	export default {

		data() {
			return {
				current: ['transactionlist'],
				openKeys: ['ordermanagement'],
				liststatus: this.$route.query.liststatus || 'have_paid',
				searchlist: {
					sku_title: null,
					trade_id: null,
					receiver_name: null,
					receiver_phone: null,
					start_time: null,
					end_time: null,
					user_id: null,
					product_channel: '0',
					nick_name: null,
				},
				dateFormat: 'YYYY-MM-DD',
				tradelist: [],
				status: {
					'to_be_paid': '待付款',
					'have_paid': '待发货',
					'delivery': '已发货',
					'finished': '已完成',
					'success': '交易成功',
					'refund': '退款售后',
					'closed': '已取消',
				},
				tradesum: 0,
				startpage: Number(this.$route.query.startpage) || 0,
				endpage: Number(this.$route.query.endpage) || 10,
				pageSize: Number(this.$route.query.pageSize) || 10,
				issearch: false,
				id_card_visible: false,
				confirmLoading: false,
				id_card_info: {
					id: null,
					real_name: null,
					id_card: null,
					id_card_front: null,
					id_card_back: null,
					phone_number: null
				},
				express_info: {
					phone_number: null,
					express_number: null,
					express_name: undefined,
					express_display: undefined,
					sync_id_card: [],
					id_card_id: null,
					remarks: null,
					send_massage: false,
					send_express_massage: false,
					massage_id: null,
					massage_info: '',
					massage_info_default: '',
					express_template_info: {},
					order_list: []
				},
				record_express: {
					express_name: null,
					express_display: null,
				},
				refund_info: {
					can_be_refund_fee: null,
					refund_fee: null,
					remark: null,
					have_express: false,
					auto_refund: false,
					// refund_express_fee:false
				},
				address_info: {
					receiver_name: null,
					receiver_address: null,
					receiver_phone: null
				},
				express_visible: false,
				expressLoading: false,
				express_data: require("./expressCode.js"),
				refund_visible: false,
				refundLoading: false,
				addressLoading: false,
				address_visible: false,
				temp_order_list: null,
				modify_price: {
					trade_total_price: null,
					trade_receipt_price: null,
					order_sku_price: null,
					order_receipt_price: null,
					order_amount: null,
					trade_id: null,
					order_id: null,
					remarks: null,
				},
				price_visible: false,
				priceLoading: false,
				operation_id: JSON.parse(sessionStorage.getItem('userinfo')).id,
				notetemplatelist: [],
				business_remarks: {
					business_remarks: undefined,
				},
				business_remarks_visible: false,
				businessRemarksLoading: false,
			}
		},
		created: function() {
			if (this.$route.query.searchlist) {
				this.searchlist = JSON.parse(this.$route.query.searchlist);
			}
			var self = this;
			this.initialize();
			this.$axios.get('/trade/notetemplate/get').then(function(res) {
				self.notetemplatelist = res.data.notetemplate;
			});
		},
		methods: {
			moment,
			tabChange(activeKey) {

				this.startpage = 0;
				this.endpage = this.pageSize;
				// this.pageSize = 10;
				this.liststatus = activeKey;
				this.$router.push({
					name: 'transactionlist',
					query: {
						startpage: this.startpage,
						endpage: this.endpage,
						pageSize: this.pageSize,
						liststatus: this.liststatus,
						searchlist: JSON.stringify(this.searchlist)
					}
				});
				this.initialize();
			},
			filterOption(input, option) {
				return (option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0) || (option.componentOptions
					.propsData.value.toLowerCase().indexOf(input.toLowerCase()) >= 0)
			},
			initialize() {
				var self = this;
				this.issearch = true;
				this.tradelist = [];
				this.tradesum = 0;
				var params = {
					searchlist: this.searchlist,
					startpage: this.startpage,
					pageSize: this.pageSize,
					liststatus: this.liststatus,
					apps_id: this.$store.state.now_app_state,
				};
				this.$axios.get('/trade/get', {
					params: params
				}).then(function(res) {
					for (var i = 0; i < res.data.tradelist.length; i++) {
						res.data.tradelist[i].TC_Delivery_Infos.forEach((item, index, arr) => {
							arr[index].query = false;
							arr[index].delivery_info = JSON.parse(arr[index].delivery_info);
						})
						res.data.tradelist[i].profitsharing_info = null;
						res.data.tradelist[i].profitsharing_fail_info = null;
						res.data.tradelist[i].ali_voucher_detail_list = JSON.parse(res.data.tradelist[i].ali_voucher_detail_list);
						// console.log(res.data.tradelist[i].ali_voucher_detail_list)
					}
					// if (self.liststatus != 'refund' && self.liststatus != 'all') {
					// 	for (var num = res.data.tradelist.length - 1; num >= 0; num--) {
					// 		var order_num = res.data.tradelist[num].TC_Orders.length;
					// 		for (var order = 0; order < res.data.tradelist[num].TC_Orders.length; order++) {
					// 			if (res.data.tradelist[num].TC_Orders[order].order_status == 'refund') {
					// 				order_num = order_num - 1;
					// 			}
					// 		}
					// 		if (order_num == 0) {
					// 			res.data.tradelist.splice(num, 1);
					// 		}
					// 	}
					// }
					self.tradelist = res.data.tradelist;
					self.tradesum = res.data.counttrade;
					self.issearch = false;
					// console.log(self.tradelist)

				});
			},
			onShowSizeChange(current, pageSize) {
				this.pageSize = pageSize;
				this.startpage = this.pageSize * (current - 1);
				this.endpage = this.pageSize * current;
				this.initialize();
				this.$router.push({
					name: 'transactionlist',
					query: {
						pageSize: this.pageSize,
						startpage: this.startpage,
						endpage: this.endpage,
						liststatus: this.liststatus,
						searchlist: JSON.stringify(this.searchlist)
					}
				})

			},
			pageChange(pageNumber) {
				this.startpage = this.pageSize * (pageNumber - 1);
				this.endpage = this.pageSize * pageNumber;
				this.initialize();

				this.$router.push({
					name: 'transactionlist',
					query: {
						pageSize: this.pageSize,
						startpage: this.startpage,
						endpage: this.endpage,
						liststatus: this.liststatus,
						searchlist: JSON.stringify(this.searchlist)
					}
				});
			},
			searchbtn() {
				this.startpage = 0;
				this.endpage = this.pageSize;
				// this.pageSize = 10;
				this.initialize();
				this.$router.push({
					name: 'transactionlist',
					query: {
						pageSize: this.pageSize,
						startpage: this.startpage,
						endpage: this.endpage,
						liststatus: this.liststatus,
						searchlist: JSON.stringify(this.searchlist)
					}
				})
			},
			changeidcard(item) {
				var self = this;
				var params = {
					id_card_id: item.id_card_id,
					address_id: item.address_id
				};
				if ((!params.id_card_id) && (!params.address_id)) {
					this.$message.error("历史订单无法查询身份证");
				} else {
					this.$axios.get('/trade/id_card/get', {
						params: params
					}).then(function(res) {
						self.id_card_info = res.data.id_card_info;
						self.id_card_visible = true;
						self.shuiyin('idimg', self.id_card_info.id_card_front, 'freshin');
					});
				}


			},
			id_card_Ok() {
				var self = this;
				if (!this.id_card_info.real_name) {
					return this.$message.error("姓名不能为空");
				}
				if (!this.id_card_info.id_card) {
					return this.$message.error("身份证号不能为空");
				}
				var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
				if (reg.test(this.id_card_info.id_card) === false) {
					return this.$message.error("身份证输入不合法");
				}
				var tempidcard = {
					id: this.id_card_info.id,
					id_card: this.id_card_info.id_card,
					real_name: this.id_card_info.real_name
				};
				this.confirmLoading = true;
				var self = this;
				this.$confirm({
					title: '提示',
					content: '是否保存身份证修改',
					okText: '确认',
					cancelText: '取消',
					onOk() {
						self.$axios.post('/trade/id_card/save', {
							params: tempidcard
						}).then(function(res) {
							if (!res.data.Message) {
								res.data.Message = "身份证修改成功"
							}
							self.$notification.open({
								message: '通知',
								description: res.data.Message,
								onClose: close,
							});
							self.id_card_visible = false;
							self.confirmLoading = false;
						})
					},
					onCancel() {
						self.confirmLoading = false;
					},
				});
			},
			id_card_Cancel() {
				this.id_card_visible = false;
				this.confirmLoading = false;
			},
			shuiyin(canvasid, imgurl, addtext) {

				var img = new Image;

				img.src = imgurl;

				img.onload = function() {

					var myImage = document.getElementById(canvasid);
					myImage.width = img.width;
					myImage.height = img.height

					var ctx = myImage.getContext("2d");

					// ctx.save();
					// if(img.width<img.height){
					// 	myImage.width = img.height;
					// 	myImage.height = img.width
					// ctx.clearRect(0, 0, myImage.width, myImage.height);
					// 	ctx.translate(img.width / 2, img.height / 2);
					// 	ctx.rotate(-90 * Math.PI / 180);
					// 	ctx.translate(-img.width / 2, -img.height / 2);
					// 	ctx.drawImage(img, 0, 0,myImage.width,myImage.width);
					// }else{
					// 	ctx.drawImage(img, 0, 0,myImage.width,myImage.height);
					// }
					// ctx.clearRect(0, 0, myImage.width, myImage.height);
					// ctx.translate(myImage.width / 2, myImage.height / 2);
					// ctx.rotate(-90 * Math.PI / 180);
					// ctx.translate(-myImage.width / 2, -myImage.height / 2);
					// ctx.drawImage(img, myImage.width / 2 - img.width / 2, myImage.height / 2 - img.height / 2);
					ctx.drawImage(img, 0, 0, img.width, img.height);

					ctx.restore();

					ctx.font = "20px 微软雅黑";
					ctx.fillStyle = "rgba(252,255,255,0.3)";
					var hline = Math.ceil(img.height / 40);
					var wline = Math.ceil(img.width / 110) + 1;

					for (var i = 0; i < hline; i++) {
						for (var j = 0; j < wline; j++) {
							if (i % 2) {
								ctx.fillText(addtext, (40 + 110 * j), (20 + (40 * i))); //选择位置	
							} else {
								ctx.fillText(addtext, (-20 + 110 * j), (20 + (40 * i))); //选择位置
							}

						}
					}
				}

			},
			exportexcel() {
				var self = this;
				var now = this.moment().format('YYYY-MM-DD-HH-mm-ss');
				var params = {
					searchlist: this.searchlist,
					liststatus: this.liststatus
				};
				this.$axios.post('/export/excel', {
					params: params
				}, {
					responseType: 'arraybuffer'
				}).then(function(res) {
					var fileDownload = require('js-file-download');
					fileDownload(res.data, (now + '.xlsx'));
				})

			},
			cancelbtn(order,cancelstatus=0) {
				var self = this;
				this.$confirm({
					title: '提示',
					content: '是否取消该订单',
					okText: '确认',
					cancelText: '取消',
					onOk() {
						self.$axios.post('/trade/cancelorder', {
							params: {
								order_id: order.id,
								trade_id: order.trade_id,
								cancelstatus:cancelstatus
							}
						}).then(function(res) {
							self.$notification.open({
								message: '通知',
								description: res.data,
								onClose: close,
							});
							self.initialize();

						})
					},
					onCancel() {},
				});
			},
			express_Ok() {
				if (!this.express_info.phone_number) {
					return this.$message.error("联系方式不能为空");
				}
				if (!this.express_info.express_name) {
					return this.$message.error("物流公司不能为空");
				}
				if (!this.express_info.express_number) {
					return this.$message.error("物流单号不能为空");
				}
				if (this.express_info.order_list.length == 0) {
					return this.$message.error("包裹中货物不能为空");
				}
				// console.log(this.express_info.massage_info.search('null'));
				if (this.express_info.send_massage && this.express_info.massage_info.search('null') !== -1) {
					return this.$message.error("短信模板中含有未知信息，请检查确认");
				}
				// return false
				this.expressLoading = true;
				this.record_express.express_name = this.express_info.express_name;
				this.record_express.express_display = this.express_info.express_display;
				var self = this;
				this.$confirm({
					title: '提示',
					content: '是否确认发货',
					okText: '确认',
					cancelText: '取消',
					onOk() {
						self.$axios.post('/trade/express', {
							params: self.express_info
						}).then(function(res) {
							self.$notification.open({
								message: '通知',
								description: res.data,
								onClose: close,
							});
							self.express_visible = false;
							self.expressLoading = false;
							self.initialize();
						})
					},
					onCancel() {
						self.expressLoading = false;
					},
				});
			},
			express_Cancel() {
				this.express_visible = false;
				this.expressLoading = false;
			},
			express_btn(trade, phone_number, id_card_id) {
				this.express_info.phone_number = phone_number;
				this.express_info.id_card_id = id_card_id;
				this.express_info.express_number = null;
				this.express_info.trade_id = trade.id;
				this.express_info.trade_number = trade.trade_number;
				this.express_info.remarks = "";
				this.express_info.order_list = [];
				this.express_info.sync_id_card = [];
				this.express_info.status = "delivery";
				this.express_info.send_massage = false;
				this.express_info.send_express_massage = false;
				this.express_visible = true;
				this.temp_order_list = trade.TC_Orders;
				this.express_info.massage_info = '';
				this.express_info.express_name = this.record_express.express_name || undefined;
				this.express_info.express_display = this.record_express.express_display || undefined;
				this.express_info.massage_id = null;
				this.express_info.massage_info_default = null;
				this.express_info.express_template_info = {
					trade_number: trade.trade_number,
					order_sku_title: null,
					trade_receiver_phone: trade.receiver_phone,
					trade_receiver_name: trade.receiver_name,
					trade_receiver_address: trade.receiver_address,
					order_sku_title: null,
				};
			},
			expressChange(value, option) {
				this.express_info.express_display = option.data.key;
				this.express_info.express_name = value;
				if (this.express_info.send_massage) {
					this.change_note_info();
				}
			},
			refund_Ok() {
				if (!this.refund_info.refund_fee) {
					return this.$message.error("退款金额不能为空");
				}
				this.refundLoading = true;
				var self = this;
				this.$confirm({
					title: '提示',
					content: '是否确认退款',
					okText: '确认',
					cancelText: '取消',
					onOk() {
						self.$axios.post('/trade/refund', {
							params: self.refund_info
						}).then(function(res) {
							self.$notification.open({
								message: '通知',
								description: res.data,
								onClose: close,
							});
							self.refund_visible = false;
							self.refundLoading = false;
							self.initialize();
						})
					},
					onCancel() {
						self.refundLoading = false;
					},
				});

			},
			refund_Cancel() {
				this.refund_visible = false;
				this.refundLoading = false;
			},
			refund_btn(order, trade) {
				// console.log(order,trade)
				this.refund_info.order_id = order.id;
				this.refund_info.trade_id = order.trade_id;
				this.refund_info.can_be_refund_fee = trade.receipt_price / 100;
				// this.refund_info.refund_fee = order.receipt_price / 100;
				this.refund_info.refund_fee = null;
				this.refund_info.remark = null;
				if (order.order_status == "refund") {
					var self = this;
					var params = {
						order_id: order.id
					};
					this.$axios.get('/trade/tc_refund', {
						params: params
					}).then(function(res) {
						self.refund_info.remark = res.data.refundinfo.remark;
						self.refund_info.user_refund = true;
						self.refund_info.have_express = false;
						self.refund_info.auto_refund = false;
						// self.refund_info.refund_express_fee = false;
						self.refund_visible = true;
					});
				} else {
					this.refund_info.have_express = false;
					this.refund_info.auto_refund = false;
					// this.refund_info.refund_express_fee = false;
					this.refund_visible = true;
				}
			},
			reject_refund_btn(order) {
				var self = this;
				var params = {
					order_id: order.id
				};
				this.$confirm({
					title: '提示',
					content: '是否确认驳回退款申请',
					okText: '确认',
					cancelText: '取消',
					onOk() {
						self.$axios.post('/trade/reject_refund', {
							params: params
						}).then(function(res) {
							self.$notification.open({
								message: '通知',
								description: res.data,
								onClose: close,
							});
							self.initialize();
						})
					},
					onCancel() {},
				});
			},
			modify_address_btn(trade) {
				this.address_info.receiver_name = trade.receiver_name;
				this.address_info.receiver_address = trade.receiver_address;
				this.address_info.receiver_phone = trade.receiver_phone;
				this.address_info.id = trade.id;
				this.address_visible = true;
			},
			address_Ok() {
				if (!this.address_info.receiver_name) {
					return this.$message.error("收件人姓名不能为空");
				}
				if (!this.address_info.receiver_address) {
					return this.$message.error("收件人地址不能为空");
				}
				if (!this.address_info.receiver_phone) {
					return this.$message.error("收件人手机号码不能为空");
				}
				this.addressLoading = true;
				var self = this;
				this.$confirm({
					title: '提示',
					content: '是否确认更改收货地址',
					okText: '确认',
					cancelText: '取消',
					onOk() {
						self.$axios.post('/trade/modify_address', {
							params: self.address_info
						}).then(function(res) {
							self.$notification.open({
								message: '通知',
								description: res.data,
								onClose: close,
							});
							self.address_visible = false;
							self.addressLoading = false;
							self.initialize();
						})
					},
					onCancel() {
						self.addressLoading = false;
					},
				});
			},
			address_Cancel() {
				this.address_visible = false;
				this.addressLoading = false;
			},
			modify_express_number_btn(trade, express) {
				var temp = JSON.parse(JSON.stringify(express));
				temp.massage_info = '';
				temp.massage_id = null;
				this.express_info = temp;
				this.express_info.send_massage = false;
				this.express_info.send_express_massage = false;
				if (typeof(this.express_info.order_list) == 'string') {
					this.express_info.order_list = JSON.parse(this.express_info.order_list)
				}
				this.express_info.status = "modify";
				this.temp_order_list = trade.TC_Orders;
				var value = this.express_info.order_list
				var text = [];
				for (var i = 0; i < value.length; i++) {
					for (var j = 0; j < this.temp_order_list.length; j++) {
						if (value[i] == this.temp_order_list[j].id) {
							text.push(this.temp_order_list[j].sku_title)
						}
					}
				}
				this.express_info.massage_info_default = null;
				this.express_info.express_template_info = {
					trade_number: trade.trade_number,
					order_sku_title: null,
					trade_receiver_phone: trade.receiver_phone,
					trade_receiver_name: trade.receiver_name,
					trade_receiver_address: trade.receiver_address,
					order_sku_title: null,
				};
				this.express_info.express_template_info.order_sku_title = text.join("、");
				this.express_visible = true;
				// console.log(this.express_info)
			},
			query_express_btn(express, status) {
				var express = express;
				express.query = !express.query
				if (status) {
					this.$axios.get('/delivery/checkone', {
						params: {
							id: express.id
						}
					}).then(function(res) {
						express.delivery_info = res.data;

					})
				}
			},
			onChangeIdCard(checkedValue) {
				this.express_info.sync_id_card = checkedValue;
			},
			daoru(info) {
				// if (info.file.status !== 'uploading') {
				// console.log(info.file, info.fileList);
				// }
				if (info.file.status === 'done') {
					this.$message.success(`${info.file.name} 文件上传成功`);
				} else if (info.file.status === 'error') {
					this.$message.error(`${info.file.name} 文件上传失败`);
				}
			},
			beforeUpload(file) {
				var reg = /^.*\.(?:xls|xlsx)$/i;
				if (!reg.test(file.name)) {
					this.$message.error('请上传excel格式的文件!')
					return false
				} else {
					return true
				}
			},
			copyaddress(item) {
				var [result] = AddressParse.parse(item.receiver_address);
				// console.log(result)
				var address_temp = result.province + " " + result.city + " " + result.area + " " + result.details + " " + result.name
				var text = item.receiver_name + "，" + item.receiver_phone + "，" + address_temp;
				if (text[text.length - 1] == " ") {
					text = text.substr(0, text.length - 1);
				}
				var oInput = document.createElement('input');
				oInput.value = text;
				document.body.appendChild(oInput);
				oInput.select(); // 选择对象;
				// console.log(oInput.value)
				document.execCommand("Copy"); // 执行浏览器复制命令
				this.$message.success('复制成功!')
				oInput.remove()

			},
			onChangeTime(date, dateString) {
				this.searchlist.start_time = dateString[0];
				this.searchlist.end_time = dateString[1];
			},
			profitsharingquery(trade) {
				var self = this;
				var params = {
					trade_id: trade.id
				}
				this.$axios.post('/trade/profitsharingquery', {
					params: params
				}).then(function(res) {
					var data = res.data.xml;
					if (data.result_code == "SUCCESS") {
						var profitsharing_info = {
							status: data.status,
							receivers: JSON.parse(data.receivers)
						}
						trade.profitsharing_info = profitsharing_info
					}
					if (data.result_code == "FAIL") {
						var profitsharing_fail_info = data.err_code_des;
						trade.profitsharing_fail_info = profitsharing_fail_info
					}

				})
			},
			profitsharingfinish(trade) {
				var self = this;
				var params = {
					trade_id: trade.id
				}
				this.$axios.post('/trade/profitsharingfinish', {
					params: params
				}).then(function(res) {
					var data = res.data.status;
					if (data) {
						self.$message.success('分账成功，请刷新页面获取最新分账信息');
					} else {
						self.$message.error('分账失败，请尝试其他方式');
					}


				})
			},
			get_first_info(trade) {
				var return_info = ''
				if (!trade.first_agency_id) {
					return_info = "该订单无一级代理";
				} else {
					return_info = "一级代理ID:" + trade.first_agency_id + " 应分金额:￥" + (trade.first_agency_rebate / 100);
				}
				return return_info;
			},
			get_second_info(trade) {
				var return_info = ''
				if (!trade.second_agency_id) {
					return_info = "该订单无二级代理";
				} else {
					return_info = "二级代理ID:" + trade.second_agency_id + " 应分金额:￥" + (trade.second_agency_rebate / 100);
				}
				return return_info;
			},
			solitaireStatus(item) {
				var one = false;
				var two = false;
				if (item.solitaire_transaction_id) {
					one = true;
				}
				if (item.transaction_id) {
					two = true;
				}
				switch (item.status) {
					case 'delivery':
						return '待收货';
					case 'finished':
						return '已完成';
					case 'success':
						return '交易成功';
					case 'to_be_paid':
						if (!one) {
							return '定金待支付'
						} else {
							return '尾款待支付'
						};
					case 'have_paid':
						if (!two) {
							return '定金已支付￥' + item.subscription / 100
						} else {
							return '尾款已支付'
						};
					case 'closed':
						if (!one) {
							return '定金未支付'
						} else {
							return '尾款未支付'
						};
				}
			},
			modify_price_btn(trade, order) {
				this.modify_price = {
					trade_number: trade.trade_number,
					trade_total_price: trade.total_price,
					trade_receipt_price: trade.receipt_price,
					order_sku_price: order.sku_price / 100,
					order_receipt_price: order.receipt_price / 100,
					order_receipt_price_history: order.receipt_price,
					trade_total_price_history: trade.total_price,
					trade_receipt_price_history: trade.receipt_price,
					order_sku_price_history: order.sku_price,
					order_amount: order.amount,
					trade_id: trade.id,
					order_id: order.id,
					remarks: null,
				}
				this.price_visible = true
			},
			price_Ok() {
				if (!this.modify_price.order_sku_price) {
					return this.$message.error("收件人姓名不能为空");
				}
				if (!this.modify_price.order_receipt_price) {
					return this.$message.error("收件人地址不能为空");
				}
				var row = {
					trade_total_price: this.modify_price.trade_total_price - this.modify_price.order_receipt_price_history +
						Number(math.format(math.multiply(this.modify_price.order_receipt_price, 100), {
							precision: 14
						})),
					trade_receipt_price: this.modify_price.trade_receipt_price - this.modify_price.order_receipt_price_history +
						Number(math.format(math.multiply(this.modify_price.order_receipt_price, 100), {
							precision: 14
						})),
					order_sku_price: Number(math.format(math.multiply(this.modify_price.order_sku_price, 100), {
						precision: 14
					})),
					order_receipt_price: Number(math.format(math.multiply(this.modify_price.order_receipt_price, 100), {
						precision: 14
					})),
					order_receipt_price_history: this.modify_price.order_receipt_price_history,
					trade_total_price_history: this.modify_price.trade_total_price_history,
					trade_receipt_price_history: this.modify_price.trade_receipt_price_history,
					order_sku_price_history: this.modify_price.order_sku_price_history,
					trade_id: this.modify_price.trade_id,
					order_id: this.modify_price.order_id,
					remarks: this.modify_price.remarks,
					operation_id: this.operation_id,
					trade_number: this.modify_price.trade_number.substring(0, 14) + this.getFormatDate()
				}
				this.priceLoading = true;

				var self = this;
				this.$confirm({
					title: '提示',
					content: '是否确认更改价格',
					okText: '确认',
					cancelText: '取消',
					onOk() {
						self.$axios.post('/trade/modify_price', {
							params: row
						}).then(function(res) {
							self.$notification.open({
								message: '通知',
								description: res.data,
								onClose: close,
							});
							self.price_visible = false;
							self.priceLoading = false;
							self.initialize();
						})
					},
					onCancel() {
						self.priceLoading = false;
					},
				});
			},
			price_Cancel() {
				this.price_visible = false;
				this.priceLoading = false;
			},
			modify_sku_price() {
				this.modify_price.order_receipt_price = this.modify_price.order_sku_price * this.modify_price.order_amount;
			},
			getFormatDate() {
				var date = new Date();
				var month = date.getMonth() + 1;
				var strDate = date.getDate();
				var hour = date.getHours();
				var minute = date.getMinutes();
				var second = date.getSeconds();
				var millissecond = date.getMilliseconds();
				if (month >= 1 && month <= 9) {
					month = "0" + month;
				}
				if (strDate >= 0 && strDate <= 9) {
					strDate = "0" + strDate;
				}
				if (hour >= 0 && hour <= 9) {
					hour = "0" + hour;
				}
				if (minute >= 0 && minute <= 9) {
					minute = "0" + minute;
				}
				if (second >= 0 && second <= 9) {
					second = "0" + second;
				}
				if (millissecond >= 0 && millissecond <= 9) {
					millissecond = "00" + millissecond;
				} else if (millissecond > 10 && millissecond <= 99) {
					millissecond = "0" + millissecond;
				}
				var currentDate = date.getFullYear() + "" + month + strDate +
					hour + minute + second + millissecond;
				return currentDate;
			},
			link_to() {
				this.$router.push('notetemplate');
			},
			order_list_change(value) {
				// console.log(this.express_info.order_list,value)
				this.express_info.order_list = value;
				var text = [];
				for (var i = 0; i < value.length; i++) {
					for (var j = 0; j < this.temp_order_list.length; j++) {
						if (value[i] == this.temp_order_list[j].id) {
							text.push(this.temp_order_list[j].sku_title)
						}
					}
				}
				this.express_info.express_template_info.order_sku_title = text.join("、");
				if (this.express_info.send_massage) {
					this.change_note_info();
				}
			},
			phone_number_change(value) {
				this.express_info.express_template_info.trade_receiver_phone = this.express_info.phone_number;
				if (this.express_info.send_massage) {
					this.change_note_info();
				}
			},
			express_number_change(value) {
				if (this.express_info.send_massage) {
					this.change_note_info();
				}
			},
			note_change(value) {
				this.express_info.massage_id = value
				var note_text = ''
				for (var i = 0; i < this.notetemplatelist.length; i++) {
					if (value == this.notetemplatelist[i].id) {
						note_text = this.notetemplatelist[i].note_text;
						break;
					}
				}
				this.express_info.massage_info_default = note_text;
				if (this.express_info.send_massage) {
					this.change_note_info();
				}
			},
			change_note_info() {
				var note_text = this.express_info.massage_info_default
				note_text = note_text.replace(/{trade_number}/g, this.express_info.express_template_info.trade_number)
				note_text = note_text.replace(/{trade_receiver_phone}/g, this.express_info.express_template_info.trade_receiver_phone)
				note_text = note_text.replace(/{trade_receiver_name}/g, this.express_info.express_template_info.trade_receiver_name)
				note_text = note_text.replace(/{trade_receiver_address}/g, this.express_info.express_template_info.trade_receiver_address)

				note_text = note_text.replace(/{delivery_number}/g, this.express_info.express_number || null)
				note_text = note_text.replace(/{delivery_express_name}/g, this.express_info.express_name || null)
				note_text = note_text.replace(/{delivery_express_display}/g, this.express_info.express_display || null)

				note_text = note_text.replace(/{order_sku_title}/g, this.express_info.express_template_info.order_sku_title || null)
				this.express_info.massage_info = note_text
			},
			modify_business_remarks_btn(trade) {
				this.business_remarks = {
					business_remarks: trade.business_remarks,
					trade_id: trade.id
				}
				this.business_remarks_visible = true
			},
			business_remarks_Cancel() {
				this.business_remarks_visible = false;
				this.businessRemarksLoading = false;
			},
			business_remarks_Ok() {
				this.businessRemarksLoading = true;
				var self = this;
				this.$confirm({
					title: '提示',
					content: '是否确认更改运营备注',
					okText: '确认',
					cancelText: '取消',
					onOk() {
						self.$axios.post('/trade/modify_business_remarks', {
							params: self.business_remarks
						}).then(function(res) {
							self.$notification.open({
								message: '通知',
								description: res.data,
								onClose: close,
							});
							self.business_remarks_visible = false;
							self.businessRemarksLoading = false;
							self.initialize();
						})
					},
					onCancel() {
						self.businessRemarksLoading = false;
					},
				});
			},
			voucher_type(ali_voucher_type) {
				switch (ali_voucher_type) {
					case "ALIPAY_COMMON_ITEM_VOUCHER":
						return "单品满减券"
						break;
					case "ALIPAY_FIX_VOUCHER":
						return "全场代金券"
						break;
					case "ALIPAY_DISCOUNT_VOUCHER":
						return "折扣券"
						break;
					default:
						return ali_voucher_type
						break;
				}
			}

		},

	};
</script>

<style>
	.transactionlist .contentcard {
		padding: 24px 50px;
		background-color: #fff;
		border-radius: 5px;
		margin-bottom: 20px;
		position: relative;
	}

	.transactionlist .card-container {
		overflow: hidden;
	}

	.transactionlist .card-container>.ant-tabs-card>.ant-tabs-content {
		min-height: 120px;
		margin-top: -16px;
	}

	.transactionlist .card-container>.ant-tabs-card>.ant-tabs-content>.ant-tabs-tabpane {
		background: #fff;
		padding: 16px;
	}

	.transactionlist .card-container>.ant-tabs-card>.ant-tabs-bar {
		border-color: #fff;
	}

	.transactionlist .card-container>.ant-tabs-card>.ant-tabs-bar .ant-tabs-tab {
		border-color: transparent;
		background: #ebebee;
		min-width: 90px;
		text-align: center;
	}

	.transactionlist .card-container>.ant-tabs-card>.ant-tabs-bar .ant-tabs-tab-active {
		border-color: #fff;
		background: #fff;
	}

	.transactionlist .ant-steps-dot .ant-steps-item-content {
		width: auto;
	}
</style>



// WEBPACK FOOTER //
// index.vue?a607abda